<template>
  <div id="teacherproducts" class="d-flex flex-column align-center">
    <v-container>
      <h2
        class="display-2 font-weight-bold mb-3 text-uppercase text-center primary--text"
      >
        {{ pageTitle }}
      </h2>

      <!-- Horizontal divider -->
      <v-responsive class="mx-auto mb-12" width="56">
        <v-divider></v-divider>
        <v-divider></v-divider>
      </v-responsive>

      <v-row>
        <v-col cols="12" sm="4">
          <v-text-field
            v-model="productsSearch"
            append-icon="mdi-magnify"
            clearable
            :label="`${$i18n.t('labels.search')}`"
            @input="changeProductsSearchQuery"
          ></v-text-field>
        </v-col>
        <v-col cols="6" sm="4">
          <v-combobox
            class="productsSearchInputCSS pt-2"
            v-model="computedProductsSearchTags"
            :label="`${$i18n.t('labels.tags')}`"
            multiple
            chips
            dense
            @change="changeProductsSearchQuery"
            min-height="36px"
            :items="syncedProductTagArray"
            deletable-chips
            clearable
            item-text="name"
            :return-object="false"
            item-value="id"
          ></v-combobox>
        </v-col>
        <!-- <v-col cols="6" sm="3">
          <v-checkbox
            v-model="viewMySubscribedProducts"
            @change="changeProductsSearchQuery"
            :disabled="
              !(syncedTeacherProfileModel?.productSubscriptions?.length > 0)
            "
            :label="`${
              $i18n.t('headings.subscribed') +
              ' ' +
              $i18n.t('headings.products')
            }`"
          ></v-checkbox>
        </v-col>
        <v-col cols="6" sm="3">
          <v-checkbox
            v-model="viewMyBoughtProducts"
            @change="changeProductsSearchQuery"
            :disabled="
              !syncedBoughtProducts || syncedBoughtProducts.length === 0
            "
            :label="`${
              $i18n.t('headings.purchasedResources')
            }`"
          ></v-checkbox>
        </v-col> -->
        <v-col cols="6" sm="4">
          <!-- <v-combobox
            class="productsSearchInputCSS pt-2"
            v-model="computedProductsSearchCategories"
            label="Categories"
            multiple
            chips
            dense
            @change="queryProducts"
            min-height="36px"
            :items="computedProductCategoryArray"
            deletable-chips
            clearable
          ></v-combobox> -->
          <v-menu
            v-model="searchProductCategoriesMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            :nudge-bottom="-12"
            :rounded="false"
          >
            <template v-slot:activator="{ on }">
              <div @click="toggleMenu">
                <v-combobox
                  class="productsSearchInputCSS pt-2"
                  :value="computedProductsSearchCategories"
                  :label="`${$i18n.t('headings.categories')}`"
                  multiple
                  chips
                  dense
                  min-height="36px"
                  clearable
                  v-on="on"
                  readonly
                  @change="changeProductsSearchCategories"
                  @click:clear="productsSearchCategories = []"
                ></v-combobox>
              </div>
            </template>
            <v-card>
              <v-card-text>
                <v-treeview
                  :items="categoryTree"
                  color="primary"
                  selected-color="primary"
                  selectable
                  item-key="id"
                  open-on-click
                  selection-type="independent"
                  v-model="productsSearchCategories"
                  @input="changeProductsSearchCategories"
                ></v-treeview>
              </v-card-text>
            </v-card>
          </v-menu>
        </v-col>
      </v-row>

      <v-row
        class="flex-row flex-wrap mx-0 mb-3"
        no-gutters
        v-if="routeCategory || mainCategories.length > 0"
        style="margin-left: -4px; margin-right: -4px"
      >
        <!-- <v-btn
          v-for="(routeCategory, categoryIndex) in routeCategoryLinksTree"
          :to="`/app/products/category/${routeCategory.id}`"
          :key="categoryIndex"
          class="mx-2"
          x-small
        >
          {{ routeCategory.name }}
        </v-btn> -->
        <div class="d-flex flex-row flex-wrap" style="gap: 8px">
          <v-btn
            @click="routeCategoriesHome"
            :small="$vuetify.breakpoint.smAndDown"
            color="primary"
            ><v-icon>mdi-home</v-icon>
          </v-btn>

          <div
            v-if="routeCategory"
            class="d-flex flex-row flex-wrap"
            style="max-width: calc(100% - 72px); gap: 8px"
          >
            <!-- <span
                style="
                  font-size: 24px;
                  line-height: 28px;
                  margin-left: 4px;
                  padding-top: 5px;
                "
              >
              </span> -->
            <!-- <template
                v-for="(routeCategory, categoryIndex) in routeCategoryLinksTree"
              >
                <v-btn
                  :key="categoryIndex"
                  color="primary"
                  @click="changeRouteCategory(routeCategory.id)"
                  class="text-wrap"
                  max-width="100%"
                >
                  {{ routeCategory.name }}
                </v-btn> -->
            <v-chip
              v-for="(routeCategory, categoryIndex) in routeCategoryLinksTree"
              :key="categoryIndex"
              color="primary"
              class="text-wrap v-btn rounded elevation-2"
              @click="changeRouteCategory(routeCategory.id)"
              style="height: 36px"
              :class="$vuetify.breakpoint.smAndDown ? 'py-1 px-2' : 'py-2'"
            >
              <v-icon
                v-show="isBundleCategory(routeCategory?.name)"
                size="20"
                color="#fae472"
                class="pulsing-star"
                >mdi-star</v-icon
              >
              {{ routeCategory.name }}
            </v-chip>
            <!-- <span
                  v-if="categoryIndex !== routeCategoryLinksTree.length - 1"
                  :key="'separator-' + categoryIndex"
                  style="font-size: 24px; line-height: 28px; padding-top: 5px"
                >
                  /
                </span> -->
            <!-- </template> -->
          </div>
        </div>
      </v-row>

      <v-row
        v-if="routeCategoryChildren.length > 0"
        style="gap: 8px"
        class="flex-row flex-wrap mx-0 mb-3"
      >
        <v-chip
          v-for="(routeChild, childIndex) in routeCategoryChildren"
          :key="childIndex"
          class="text-wrap v-btn rounded elevation-2"
          @click="changeRouteCategory(routeChild.id)"
          style="height: 36px"
          :class="[
            $vuetify.breakpoint.smAndDown ? 'py-1 px-2' : 'py-2',
            {
              'bundle-chip': isBundleCategory(routeChild?.name),
            },
          ]"
        >
          <v-icon
            v-show="isBundleCategory(routeChild?.name)"
            size="20"
            color="primary"
            class="pulsing-star"
            >mdi-star</v-icon
          >
          {{ routeChild.name }}
        </v-chip>
        <!-- <v-btn
            v-for="(routeChild, childIndex) in routeCategoryChildren"
            :key="childIndex"
            @click="changeRouteCategory(routeChild.id)"
          >
            {{ routeChild.name }}
          </v-btn> -->
      </v-row>
      <v-row
        v-else-if="!routeCategory"
        style="gap: 8px"
        class="flex-row flex-wrap mx-0 mb-3"
      >
        <!-- <v-btn
            v-for="(mainCategory, mainCategoryIndex) in mainCategories"
            :key="mainCategoryIndex"
            @click="changeRouteCategory(mainCategory.id)"
          >
            {{ mainCategory.name }}
          </v-btn> -->
        <v-chip
          v-for="(mainCategory, mainCategoryIndex) in mainCategories"
          :key="mainCategoryIndex"
          @click="changeRouteCategory(mainCategory.id)"
          class="text-wrap v-btn rounded elevation-2"
          style="height: 36px"
          :class="[
            $vuetify.breakpoint.smAndDown ? 'py-1 px-2' : 'py-2',
            {
              'bundle-chip': isBundleCategory(mainCategory?.name),
            },
          ]"
        >
          <v-icon
            v-show="isBundleCategory(mainCategory?.name)"
            size="20"
            color="primary"
            class="pulsing-star"
            >mdi-star</v-icon
          >
          {{ mainCategory.name }}
        </v-chip>
      </v-row>

      <v-row v-if="!isDataFullySynced && products.length === 0">
        <v-col cols="12" class="d-flex align-center justify-center pa-4 pb-6">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col
          v-for="product in products"
          :key="product.id"
          cols="12"
          sm="6"
          md="4"
          lg="3"
        >
          <v-card
            elevation="2"
            min-height="fit-content"
            height="100%"
            @mouseover="hoverIndex = product.id"
            @mouseleave="hoverIndex = null"
            @click="selectProduct(product.id)"
            class="d-flex flex-column justify-space-between"
          >
            <div class="pb-4">
              <v-card-title
                v-if="recommendedDiscountMap.get(product.id) > 0"
                class="primary justify-center py-1 rounded text-overline"
              >
                <v-spacer></v-spacer>Recommended
                <v-spacer></v-spacer>
                <v-icon color="black"> mdi-thumb-up </v-icon>
              </v-card-title>
              <v-card-title
                v-else-if="product.featured === true"
                class="secondary justify-center py-1 rounded text-overline"
              >
                <v-spacer></v-spacer>{{ $i18n.t("headings.featured") }}
                <v-spacer></v-spacer>
                <v-icon color="black"> mdi-star </v-icon>
              </v-card-title>
            </div>
            <div
              @mouseenter="mouseOverProductThumbnail(product.id)"
              @mouseleave="mouseOutProductThumbnail(product.id)"
              style="min-height: 200px; max-height: 200px"
            >
              <v-img
                :src="
                  hoverIndex === product.id &&
                  product.thumbnailImages.length > 1
                    ? product.thumbnailImages[1]
                    : product.thumbnailImages[0]
                "
                height="200"
                contain
                :loading="!isImageLoaded(product.id, product.thumbnailImages)"
                v-intersect="
                  (entries) => {
                    if (entries[0].isIntersecting) {
                      loadThumbnail(entries, product.id);
                    }
                  }
                "
              >
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0 align-center justify-center">
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </div>

            <v-card-title
              style="
                font-size: 1.25rem;
                line-height: 1.4rem;
                text-decoration: none !important;
                word-break: break-word;
              "
            >
              {{ product.title }}
            </v-card-title>

            <div
              v-if="
                syncedTeacherProfileModel?.productSubscriptions?.some(
                  (subscription) => subscription.productId === product.id,
                ) ||
                syncedBoughtProducts?.some((id) => id === product.id) ||
                hasSchoolAccess(product.id) ||
                syncedPendingProducts?.some((id) => id === product.id)
              "
            >
              <v-card-actions class="justify-end primary--text">
                <v-chip
                  v-if="isProductTaggedAs(product.tags, 'Latest ATP')"
                  x-small
                  label
                  color="blue"
                  text-color="white"
                  class="text-overline px-1"
                >
                  Latest ATP
                </v-chip>

                <v-chip
                  v-else-if="isProductTaggedAs(product.tags, 'Latest TAPS')"
                  x-small
                  label
                  color="green"
                  text-color="white"
                  class="text-overline px-1"
                >
                  Latest TAPS
                </v-chip>

                <v-chip
                  v-else-if="isProductTaggedAs(product.tags, 'SBA Based')"
                  x-small
                  label
                  color="purple"
                  text-color="white"
                  class="text-overline px-1"
                >
                  SBA Based
                </v-chip>

                <v-chip
                  v-else-if="isProductTaggedAs(product.tags, 'CAPS/KABV')"
                  x-small
                  label
                  color="orange"
                  text-color="white"
                  class="text-overline px-1"
                >
                  CAPS/KABV
                </v-chip>
                <v-spacer> </v-spacer>
                &nbsp;

                <v-tooltip
                  top
                  v-if="syncedPendingProducts?.some((id) => id === product.id)"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="primary" v-bind="attrs" v-on="on">
                      mdi-cart-check
                    </v-icon>
                  </template>
                  <span>In Cart</span>
                </v-tooltip>

                <v-tooltip
                  top
                  v-else-if="
                    syncedTeacherProfileModel?.productSubscriptions?.some(
                      (subscription) => subscription.productId === product.id,
                    )
                  "
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="primary" v-bind="attrs" v-on="on">
                      mdi-book-check
                    </v-icon>
                  </template>
                  <span>Subscribed</span>
                </v-tooltip>

                <v-tooltip
                  top
                  v-else-if="
                    syncedBoughtProducts?.some((id) => id === product.id)
                  "
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="primary" v-bind="attrs" v-on="on">
                      mdi-cash-check
                    </v-icon>
                  </template>
                  <span>Bought</span>
                </v-tooltip>

                <v-tooltip top v-else-if="hasSchoolAccess(product.id)">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="primary" v-bind="attrs" v-on="on">
                      mdi-school
                    </v-icon>
                  </template>
                  <span>School Package</span>
                </v-tooltip>
              </v-card-actions>
            </div>
            <v-card-actions v-else class="justify-end primary--text">
              <!-- <v-tooltip top v-if="isProductNew(product.publishDate)">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="primary" v-bind="attrs" v-on="on">
                    mdi-new-box
                  </v-icon>
                </template>
                <span>New!</span>
              </v-tooltip> -->
              <!-- <v-chip
                v-if="isProductNew(product.publishDate)"
                x-small
                label
                color="red"
                text-color="white"
                class="text-overline px-1 mr-1"
              >
                NEW
              </v-chip> -->

              <v-chip
                v-if="isProductTaggedAs(product.tags, 'Latest ATP')"
                x-small
                label
                color="blue"
                text-color="white"
                class="text-overline px-1"
              >
                Latest ATP
              </v-chip>

              <v-chip
                v-else-if="isProductTaggedAs(product.tags, 'Latest TAPS')"
                x-small
                label
                color="green"
                text-color="white"
                class="text-overline px-1"
              >
                Latest TAPS
              </v-chip>

              <v-chip
                v-else-if="isProductTaggedAs(product.tags, 'SBA Based')"
                x-small
                label
                color="purple"
                text-color="white"
                class="text-overline px-1"
              >
                SBA Based
              </v-chip>

                <v-chip
                  v-else-if="isProductTaggedAs(product.tags, 'CAPS/KABV')"
                  x-small
                  label
                  color="orange"
                  text-color="white"
                  class="text-overline px-1"
                >
                  CAPS/KABV
                </v-chip>

              <v-tooltip
                top
                v-if="
                  product.price &&
                  (product.effectiveDiscount || product.discountPercentage) > 0
                "
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="#FFD700" v-bind="attrs" v-on="on"
                    >mdi-sale</v-icon
                  >
                </template>
                <span>Sale!</span>
              </v-tooltip>

              <v-tooltip top v-else-if="!product.price">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="#FFD700" v-bind="attrs" v-on="on">
                    mdi-gift
                  </v-icon>
                </template>
                <span>Free!</span>
              </v-tooltip>

              <v-tooltip
                top
                v-if="!product.addons ? false : hasAddons(product.addons)"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="#00f6fe" v-bind="attrs" v-on="on">
                    mdi-toy-brick-plus
                  </v-icon>
                </template>
                <span>Add-ons</span>
              </v-tooltip>
              <v-spacer> </v-spacer>
              <div
                class="font-weight-medium"
                v-html="
                  productPrice(
                    product.price,
                    product.effectiveDiscount || product.discountPercentage,
                  )
                "
              ></div>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <!-- View more button -->
      <v-btn
        v-if="products.length > 0"
        color="primary"
        class="mt-5"
        :class="
          screenWidth < 355 ? 'mb-16' : screenWidth < 577 ? 'mb-12' : 'mb-6'
        "
        @click="loadMore"
        >{{ $i18n.t("actions.view") + " " + $i18n.t("labels.more") }}</v-btn
      >
      <div
        v-else-if="isDataFullySynced && products.length === 0"
        class="d-flex align-center justify-center pa-4"
      >
        <span
          >There are no resources found for the current search criteria. Try
          selecting another subject above or remove tag/category selections from
          the dropdown fields above.</span
        >
      </div>
    </v-container>

    <v-dialog
      v-if="productSelectDialog"
      v-model="productSelectDialog"
      :max-width="screenWidth > 1400 ? '1200px' : ''"
    >
      <div
        ref="productDialogDiv"
        style="max-height: 89vh"
        :class="
          $vuetify.breakpoint.smAndDown ? 'overflow-y-auto' : 'overflow-hidden'
        "
      >
        <v-card>
          <v-toolbar ref="toolbar" style="gap: 12px" flat dense class="py-1">
            <v-badge
              v-if="syncedPendingProducts?.length > 0"
              :content="syncedPendingProducts.length"
              :value="syncedPendingProducts.length"
              color="secondary"
              overlap
              class="badge-black-text"
              offset-y="15"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    fab
                    small
                    depressed
                    @click="openCartDialog"
                    color="primary"
                  >
                    <v-icon>mdi-cart-outline</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("products.shoppingCart") }}</span>
              </v-tooltip>
            </v-badge>
            <v-spacer></v-spacer>

            <!-- <v-tooltip left v-if="userOwnsProduct && !selectedProduct.products">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                icon
                @click="openAIChatDialog">
            <img :src="require('@/assets/juffrou-anri-animate-head.webp')" width="48" height="48"/>
          </v-btn>
            </template>
            <span>Ask AI</span>
          </v-tooltip> -->

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  @click="shareProduct(selectedProduct)"
                >
                  <v-icon>mdi-share</v-icon>
                </v-btn>
              </template>
              <span>{{ $i18n.t("actions.share") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  @click="closeSelectProductDialog"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <span>{{ $i18n.t("actions.close") }}</span>
            </v-tooltip>
          </v-toolbar>

          <!-- <div class="overflow-x-hidden overflow-y-auto" :style="`max-height:calc(89vh - (${similarProductsHeight}px + 64px))`"> -->
          <v-row
            no-gutters
            class="overflow-x-hidden overflow-y-auto"
            :style="`max-height:calc(89vh - (${
              $vuetify.breakpoint.smAndDown ? '48' : similarProductsHeight
            }px + 64px))`"
          >
            <div
              :style="
                screenWidth >= 1200
                  ? 'flex: 0 0 35%; max-width: 35%'
                  : screenWidth >= 800
                  ? 'flex: 0 0 50%; max-width: 50%'
                  : 'flex: 0 0 100%; max-width: 100%'
              "
              class="pa-6"
            >
              <MediaGallery
                v-if="
                  selectedProduct.displayItems &&
                  selectedProduct.displayItems.length > 0
                "
                :key="selectedProduct.id"
                :items="selectedProduct.displayItems"
                :aspect-ratio="1"
                :thumb-size="64"
                :max-stage-height="450"
                :video-controls="true"
                :video-autoplay="false"
                :video-loop="true"
                active-color="#ffa9b8"
                hover-color="#fae472"
              />
            </div>

            <div
              v-if="screenWidth >= 800"
              :style="
                screenWidth >= 1200
                  ? 'flex: 0 0 35%; max-width: 35%'
                  : 'flex: 0 0 50%; max-width: 50%'
              "
              class="pa-6"
            >
              <v-card-title class="px-0 pt-0 pb-2">
                <span
                  class="text-h5 font-weight-bold"
                  style="word-break: normal"
                  >{{ selectedProduct.title }}</span
                >
              </v-card-title>
              <v-card-subtitle
                class="pa-0 pt-2"
                v-if="computeSelectedProductCategory() !== ''"
              >
                {{ $i18n.t("headings.category") }}:
                <span class="grey--text">{{
                  computeSelectedProductCategory()
                }}</span>
              </v-card-subtitle>
              <v-card-subtitle
                class="px-0 py-1"
                v-if="computeSelectedProductTags() !== ''"
              >
                {{ $i18n.t("labels.tags") }}:
                <span class="grey--text">{{
                  computeSelectedProductTags()
                }}</span>
              </v-card-subtitle>
              <div v-if="screenWidth >= 1200">
                <div v-if="selectedProduct.products">
                  <p class="text-subtitle-2">
                    {{ $i18n.t("headings.products") }}
                  </p>
                  <v-row style="gap: 8px" no-gutters class="mb-2">
                    <v-chip
                      v-for="(
                        bundleProduct, pIndex
                      ) in selectedProduct.products"
                      :key="pIndex"
                      color="primary"
                      class="text-wrap py-1"
                      @click="viewBundleProduct(bundleProduct.id)"
                      style="height: fit-content"
                      >{{ bundleProduct.title }}</v-chip
                    ></v-row
                  >
                </div>

                <v-expansion-panels
                  flat
                  v-if="selectedProduct.description"
                  v-model="selectedProductDescriptionPanel"
                >
                  <v-expansion-panel @change="changeProductDescriptionPanel">
                    <v-expansion-panel-header class="text-subtitle-2 pl-0">{{
                      $i18n.t("headings.product") +
                      " " +
                      $i18n.t("labels.details")
                    }}</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <div
                        class="pt-2 tiptap"
                        v-html="selectedProduct.description"
                      ></div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <!-- <div
                class="pt-2 tiptap"
                v-html="selectedProduct.description"
              ></div> -->
              </div>
              <div v-else>
                <!-- <v-card-title class="px-0 pt-0 pb-2">
                  <span class="text-h5 font-weight-bold">{{
                    `R ${Number(selectedProduct.price).toFixed(2)}`
                  }}</span>
                </v-card-title>
                <v-card-subtitle class="px-0 py-2 grey--text">
                  {{ selectedProductVat }}
                </v-card-subtitle> -->

                <!-- HIDE-subscription-17Dec2024 -->

                <!-- <v-btn
                v-if="productAddToMyLibrary"
                color="primary"
                :disabled="gettingProductContent"
                :loading="gettingProductContent"
                @click="saveGetProductContent"
                class="mt-1"
                block
                >{{ $i18n.t("products.addToMyLibrary") }}</v-btn
              >
              <v-btn
                v-else-if="productDownloadLimitReached"
                color="warning"
                to="/app/profile"
                block
                class="mt-1"
                >{{ currentMonthLimit() }}</v-btn
              >
              <v-btn
                v-else-if="productSubToGradeToDownload"
                color="warning"
                to="/app/profile"
                block
                class="mt-1"
                >{{ $i18n.t("products.subToGradeToDownload") }}</v-btn
              > -->
                <span
                  v-if="productBundleShowContent"
                  class="font-weight-bold primary--text mt-1"
                  style="font-family: 'Delight', sans-serif; font-size: 1.3rem"
                  >{{ $i18n.t("headings.showBundleContent") }}</span
                >
                <v-btn
                  v-if="productShowContent"
                  color="primary"
                  :disabled="gettingProductContent"
                  :loading="gettingProductContent"
                  @click="showProductContentDialog"
                  block
                  class="mt-1"
                  >{{
                    $i18n.t("actions.show") + " " + $i18n.t("headings.content")
                  }}</v-btn
                >
                <!-- <v-btn
                v-else-if="productSubscribable"
                color="warning"
                class="mt-1"
                to="/app/profile"
                block
                >{{ $i18n.t("products.subToDownload") }}</v-btn
              > -->
                <div
                  v-if="productBuyable"
                  class="d-flex flex-column text-center"
                  style="gap: 8px"
                >
                  <!-- <span
                  class="text-h6 pt-2 text-uppercase"
                  v-show="productSubscribable"
                  >{{ $i18n.t("otherText.or") }}</span
                > -->
                  <div
                    class="primary--text font-weight-medium"
                    v-html="selectedProductPrice"
                  ></div>
                  <div
                    v-if="selectedProduct.isRecommendedDiscount"
                    style="margin-top: -10px"
                  >
                    Once-off discount opportunity
                  </div>
                  <v-btn
                    color="primary"
                    @click="attemptBuyProduct()"
                    block
                    :loading="
                      savingProductToCart ||
                      (userSignedIn &&
                        (!syncedTeacherProfile || !syncedTeacherProductsOrders))
                    "
                    :disabled="
                      productExistsOnPendingOrder ||
                      offline ||
                      (userSignedIn &&
                        (!syncedTeacherProfile || !syncedTeacherProductsOrders))
                    "
                    >{{ $i18n.t("products.buyNow") }}
                  </v-btn>
                </div>

                <v-card-subtitle class="px-0 py-3">
                  Resource Use Disclaimer:
                  <span class="grey--text"
                    >Juffrou Anri resources are designed to support teaching and
                    learning. They are provided as professional support
                    materials and are not positioned as secure,
                    ready-to-administer classroom or assessment instruments.
                    Educators and caregivers remain responsible for determining
                    whether, how, and in what context resources are used, in
                    accordance with their learners’ needs, school policies, and
                    applicable educational guidelines.</span
                  >
                </v-card-subtitle>
              </div>
            </div>

            <div
              v-if="screenWidth >= 1200"
              style="flex: 0 0 30%; max-width: 30%"
              class="py-6 pr-6 d-flex flex-column justify-space-between"
            >
              <div>
                <!-- <v-card-title class="px-0 pt-0 pb-2">
                  <span class="text-h5 font-weight-bold">{{
                    `R ${Number(selectedProduct.price).toFixed(2)}`
                  }}</span>
                </v-card-title>
                <v-card-subtitle class="px-0 py-2 grey--text">
                  {{ selectedProductVat }}
                </v-card-subtitle> -->

                <!-- HIDE-subscription-17Dec2024 -->

                <!-- <v-btn
                v-if="productAddToMyLibrary"
                color="primary"
                :disabled="gettingProductContent"
                :loading="gettingProductContent"
                @click="saveGetProductContent"
                block
                class="mt-1"
                >{{ $i18n.t("products.addToMyLibrary") }}</v-btn
              >
              <v-btn
                v-else-if="productDownloadLimitReached"
                color="warning"
                to="/app/profile"
                block
                class="mt-1"
                >{{ currentMonthLimit() }}</v-btn
              >
              <v-btn
                v-else-if="productSubToGradeToDownload"
                color="warning"
                to="/app/profile"
                block
                class="mt-1"
                >{{ $i18n.t("products.subToGradeToDownload") }}</v-btn
              > -->
                <span
                  v-if="productBundleShowContent"
                  class="font-weight-bold primary--text mt-1"
                  style="font-family: 'Delight', sans-serif; font-size: 1.3rem"
                  >{{ $i18n.t("headings.showBundleContent") }}</span
                >
                <v-btn
                  v-if="productShowContent"
                  color="primary"
                  :disabled="gettingProductContent"
                  :loading="gettingProductContent"
                  @click="showProductContentDialog"
                  block
                  class="mt-1"
                  >{{
                    $i18n.t("actions.show") + " " + $i18n.t("headings.content")
                  }}</v-btn
                >
                <!-- <v-btn
                v-else-if="productSubscribable"
                color="warning"
                class="mt-1"
                to="/app/profile"
                block
                >{{ $i18n.t("products.subToDownload") }}</v-btn
              > -->
                <div
                  v-if="productBuyable"
                  class="d-flex flex-column text-center"
                  style="gap: 8px"
                >
                  <!-- <span
                  class="text-h6 pt-2 text-uppercase"
                  v-show="productSubscribable"
                  >{{ $i18n.t("otherText.or") }}</span
                > -->
                  <div
                    class="primary--text font-weight-medium"
                    v-html="selectedProductPrice"
                  ></div>
                  <div
                    v-if="selectedProduct.isRecommendedDiscount"
                    style="margin-top: -10px"
                  >
                    Once-off discount opportunity
                  </div>
                  <v-btn
                    color="primary"
                    @click="attemptBuyProduct()"
                    block
                    :loading="
                      savingProductToCart ||
                      (userSignedIn &&
                        (!syncedTeacherProfile || !syncedTeacherProductsOrders))
                    "
                    :disabled="
                      productExistsOnPendingOrder ||
                      offline ||
                      (userSignedIn &&
                        (!syncedTeacherProfile || !syncedTeacherProductsOrders))
                    "
                    >{{ $i18n.t("products.buyNow") }}</v-btn
                  >
                </div>

                <v-card-subtitle class="px-0 py-3">
                  Resource Use Disclaimer:
                  <span class="grey--text"
                    >Juffrou Anri resources are designed to support teaching and
                    learning. They are provided as professional support
                    materials and are not positioned as secure,
                    ready-to-administer classroom or assessment instruments.
                    Educators and caregivers remain responsible for determining
                    whether, how, and in what context resources are used, in
                    accordance with their learners’ needs, school policies, and
                    applicable educational guidelines.</span
                  >
                </v-card-subtitle>
              </div>
              <!-- <div class="d-flex justify-end" style="gap: 1.5rem">
              <v-badge
                v-if="syncedPendingProducts?.length > 0"
                :content="syncedPendingProducts.length"
                :value="syncedPendingProducts.length"
                color="secondary"
                overlap
                class="badge-black-text"
                offset-y="10"
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                      @click="openCartDialog"
                      color="primary"
                    >
                      <v-icon>mdi-cart-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $i18n.t("products.shoppingCart") }}</span>
                </v-tooltip>
              </v-badge>
              <v-btn
                color="secondary"
                class="black--text"
                @click="closeSelectProductDialog"
                >{{ $i18n.t("actions.close") }}</v-btn
              >
            </div> -->
            </div>

            <v-col v-if="screenWidth < 800" cols="12" class="px-6 pb-6 pt-0">
              <!-- HIDE-subscription-17Dec2024 -->

              <!-- <v-btn
              v-if="productAddToMyLibrary"
              color="primary"
              :disabled="gettingProductContent"
              :loading="gettingProductContent"
              @click="saveGetProductContent"
              block
              class="mb-6"
              >{{ $i18n.t("products.addToMyLibrary") }}</v-btn
            >
            <v-btn
              v-else-if="productDownloadLimitReached"
              color="warning"
              to="/app/profile"
              block
              class="mb-6"
              >{{ currentMonthLimit() }}</v-btn
            >
            <v-btn
              v-else-if="productSubToGradeToDownload"
              color="warning"
              to="/app/profile"
              block
              class="mb-6"
              >{{ $i18n.t("products.subToGradeToDownload") }}</v-btn
            > -->

              <div class="mb-2">
                <span
                  v-if="productBundleShowContent"
                  class="font-weight-bold primary--text"
                  style="font-family: 'Delight', sans-serif; font-size: 1.3rem"
                  >{{ $i18n.t("headings.showBundleContent") }}</span
                >
              </div>

              <v-btn
                v-if="productShowContent"
                color="primary"
                class="mb-6"
                :disabled="gettingProductContent"
                :loading="gettingProductContent"
                @click="showProductContentDialog"
                block
                >{{
                  $i18n.t("actions.show") + " " + $i18n.t("headings.content")
                }}</v-btn
              >
              <!-- <v-btn
              v-else-if="productSubscribable"
              color="warning"
              class="mb-6"
              to="/app/profile"
              block
              >{{ $i18n.t("products.subToDownload") }}</v-btn
            > -->
              <div
                v-if="productBuyable"
                class="d-flex flex-column text-center"
                style="gap: 8px"
              >
                <!-- <span
                class="text-h6 pt-2 text-uppercase"
                v-show="productSubscribable"
                >{{ $i18n.t("otherText.or") }}</span
              > -->
                <div
                  class="primary--text font-weight-medium"
                  v-html="selectedProductPrice"
                ></div>
                <div
                  v-if="selectedProduct.isRecommendedDiscount"
                  style="margin-top: -10px"
                >
                  Once-off discount opportunity
                </div>
                <v-btn
                  color="primary"
                  @click="attemptBuyProduct()"
                  block
                  class="mb-6"
                  :loading="
                    savingProductToCart ||
                    (userSignedIn &&
                      (!syncedTeacherProfile || !syncedTeacherProductsOrders))
                  "
                  :disabled="
                    productExistsOnPendingOrder ||
                    offline ||
                    (userSignedIn &&
                      (!syncedTeacherProfile || !syncedTeacherProductsOrders))
                  "
                  >{{ $i18n.t("products.buyNow") }}
                </v-btn>
              </div>

              <v-card-title class="px-0 pt-0 pb-2">
                <span
                  class="text-h5 font-weight-bold"
                  style="word-break: normal"
                  >{{ selectedProduct.title }}</span
                >
              </v-card-title>
              <!-- <v-card-subtitle
              class="px-0 py-2 grey--text"
              v-if="selectedProduct.tags.length > 0"
            >
              {{ selectedProduct.tags.join(" / ") }}
            </v-card-subtitle> -->
              <v-card-subtitle
                class="pa-0 pt-2"
                v-if="computeSelectedProductCategory() !== ''"
              >
                {{ $i18n.t("headings.category") }}:
                <span class="grey--text">{{
                  computeSelectedProductCategory()
                }}</span>
              </v-card-subtitle>
              <v-card-subtitle
                class="px-0 py-1"
                v-if="computeSelectedProductTags() !== ''"
              >
                {{ $i18n.t("labels.tags") }}:
                <span class="grey--text">{{
                  computeSelectedProductTags()
                }}</span>
              </v-card-subtitle>
              <!-- <v-card-title class="px-0 pt-0 pb-2">
                <span class="text-h5 font-weight-bold">{{
                  `R ${Number(selectedProduct.price).toFixed(2)}`
                }}</span>
              </v-card-title>
              <v-card-subtitle class="px-0 py-2 grey--text">
                {{ selectedProductVat }}
              </v-card-subtitle> -->
            </v-col>

            <v-col
              v-if="screenWidth < 1200"
              :cols="screenWidth < 800 ? '12' : '10'"
              class="px-6 pb-6"
            >
              <div v-if="selectedProduct.products">
                <p class="text-subtitle-2">
                  {{ $i18n.t("headings.products") }}
                </p>
                <v-row style="gap: 8px" no-gutters class="mb-2">
                  <v-chip
                    v-for="(bundleProduct, pIndex) in selectedProduct.products"
                    :key="pIndex"
                    color="primary"
                    class="text-wrap py-1"
                    @click="viewBundleProduct(bundleProduct.id)"
                    style="height: fit-content"
                    >{{ bundleProduct.title }}</v-chip
                  ></v-row
                >
              </div>

              <v-expansion-panels
                flat
                v-if="selectedProduct.description"
                v-model="selectedProductDescriptionPanel"
              >
                <v-expansion-panel @change="changeProductDescriptionPanel">
                  <v-expansion-panel-header class="text-subtitle-2 pl-0">{{
                    $i18n.t("headings.product") +
                    " " +
                    $i18n.t("labels.details")
                  }}</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div
                      class="pt-2 tiptap"
                      v-html="selectedProduct.description"
                    ></div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>

              <v-card-subtitle class="px-0 pt-2 pb-0" v-if="screenWidth < 800">
                Resource Use Disclaimer:
                <span class="grey--text"
                  >Juffrou Anri resources are designed to support teaching and
                  learning. They are provided as professional support materials
                  and are not positioned as secure, ready-to-administer
                  classroom or assessment instruments. Educators and caregivers
                  remain responsible for determining whether, how, and in what
                  context resources are used, in accordance with their learners’
                  needs, school policies, and applicable educational
                  guidelines.</span
                >
              </v-card-subtitle>
            </v-col>

            <!--  <v-col v-if="userOwnsProduct" cols="12" class="pa-0">
    <h3 class="pa-2">Ask questions about this product</h3>
    <v-textarea
      v-model="aiQuestion"
      label="Ask a question about this product"
      placeholder="e.g., What's on page 65 of the lesson planning PDF?"
      outlined
      clearable
      @keyup.enter="submitAIQuestion"
    ></v-textarea>
    <v-btn
      color="primary"
      :disabled="!aiQuestion || submittingAIQuestion"
      :loading="submittingAIQuestion"
      @click="submitAIQuestion"
    >
      Submit Question
    </v-btn>
    <div v-if="aiAnswer" class="pa-2">
      <strong>Answer:</strong>
      <div v-html="aiAnswer"></div>
    </div>
  </v-col> -->
          </v-row>

          <!-- <v-card-actions  class="justify-end pa-4" style="gap: 12px">
              <v-badge
                v-if="syncedPendingProducts?.length > 0"
                :content="syncedPendingProducts.length"
                :value="syncedPendingProducts.length"
                color="secondary"
                overlap
                class="badge-black-text"
                offset-y="10"
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                      @click="openCartDialog"
                      color="primary"
                    >
                      <v-icon>mdi-cart-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $i18n.t("products.shoppingCart") }}</span>
                </v-tooltip>
              </v-badge>
              <v-btn
                color="secondary"
                class="black--text"
                @click="closeSelectProductDialog"
                >{{ $i18n.t("actions.close") }}</v-btn
              >
        </v-card-actions>
        </div> -->
        </v-card>

        <v-card
          ref="productDialogSimilarProductsCard"
          color="primary"
          height="auto"
          min-height="max-content"
        >
          <v-expansion-panels
            v-show="hasSimilarProducts"
            v-model="similarProductsPanel"
            ref="similarProductsPanelRef"
            class="similar-products-expand-panels"
            flat
          >
            <v-expansion-panel @change="changeSimilarProductsPanel">
              <v-expansion-panel-header color="primary" class="py-0">
                <span class="white--text text-subtitle-1"
                  >Frequently bought together</span
                >
              </v-expansion-panel-header>
              <v-expansion-panel-content eager>
                <SimilarProductsCarousel
                  :similarProducts="similarProducts"
                  @select="selectProduct"
                  @has-similar-products="setHasSimilarProducts"
                  @add-to-cart="directBuyProduct"
                />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-card-actions
            v-if="
              syncedPendingProducts?.length > 0 &&
              showCartInSimilarProductsPanel &&
              similarProductsPanel === 0
            "
            class="justify-end px-6 pb-3 pt-0"
          >
            <v-badge
              :content="syncedPendingProducts?.length || 0"
              :value="syncedPendingProducts?.length > 0"
              color="secondary"
              overlap
              class="badge-black-text z-index-100"
              offset-y="15"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    fab
                    small
                    depressed
                    @click.stop="openCartDialog"
                    color="white"
                  >
                    <v-icon color="primary">mdi-cart-outline</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("products.shoppingCart") }}</span>
              </v-tooltip>
            </v-badge>
          </v-card-actions>
        </v-card>
      </div>
    </v-dialog>

    <v-dialog
      persistent
      v-if="physicalQuestionsDialog"
      v-model="physicalQuestionsDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="justify-center">
          <span class="text-h4">Product Questions</span>
        </v-card-title>

        <v-form
          ref="productQuestionsForm"
          v-model="validQuestions"
          @submit.prevent="addToCart"
        >
          <v-row class="ma-4 flex-column">
            <template
              v-for="(question, questionIndex) in (
                buyingProduct || selectedProduct
              ).questions"
            >
              <v-text-field
                v-if="question.type === 'Text'"
                :key="'text-' + questionIndex"
                v-model="question.value"
                :label="question.label"
                :hint="question.hint"
                :placeholder="question.placeholder"
                @dblclick="copyPlaceholderToValue(question)"
                :required="question.required"
                :rules="question.required ? formRules.required : []"
              ></v-text-field>
              <v-textarea
                v-if="question.type === 'Textarea'"
                :key="'textarea-' + questionIndex"
                v-model="question.value"
                :label="question.label"
                :hint="question.hint"
                :placeholder="question.placeholder"
                @dblclick="copyPlaceholderToValue(question)"
                auto-grow
                :required="question.required"
                :rules="question.required ? formRules.required : []"
              ></v-textarea>
              <v-select
                v-if="
                  question.type === 'Select' || question.type === 'Multi Select'
                "
                :key="'select-' + questionIndex"
                v-model="question.value"
                :label="question.label"
                :items="question.items"
                :hint="question.hint"
                :placeholder="question.placeholder"
                :multiple="question.type === 'Multi Select'"
                :required="question.required"
                :rules="question.required ? formRules.required : []"
              ></v-select>
              <v-radio-group
                v-if="question.type === 'Radio'"
                :key="'radio-' + questionIndex"
                v-model="question.value"
                :label="question.label"
                :hint="question.hint"
                :rules="question.required ? formRules.required : []"
              >
                <v-radio
                  v-for="(item, itemIndex) in question.items"
                  :key="'item-' + itemIndex"
                  :label="item"
                  :value="item"
                ></v-radio>
              </v-radio-group>
              <div
                v-if="question.type === 'Checkbox'"
                :key="'checkbox-container-' + questionIndex"
              >
                <span class="v-label">{{ question.label }}</span>
                <template>
                  <v-checkbox
                    v-for="(item, itemIndex) in question.items"
                    :key="'checkbox-' + questionIndex + '-' + itemIndex"
                    v-model="question.value"
                    :value="item"
                    :label="item"
                    :rules="question.required ? formRules.required : []"
                  ></v-checkbox>
                </template>
              </div>
            </template>
          </v-row>

          <v-card-actions>
            <v-btn
              color="secondary"
              class="black--text"
              @click="closePhysicalQuestionsDialog"
              >{{ $i18n.t("actions.close") }}</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              @click="addToCart()"
              :loading="
                savingProductToCart ||
                (userSignedIn &&
                  (!syncedTeacherProfile || !syncedTeacherProductsOrders))
              "
              :disabled="
                productExistsOnPendingOrder ||
                !validQuestions ||
                offline ||
                (userSignedIn &&
                  (!syncedTeacherProfile || !syncedTeacherProductsOrders))
              "
              >{{ $i18n.t("products.addToCart") }}</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog
      v-if="selectedProductContent"
      persistent
      v-model="productContentDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="justify-center">
          <span class="text-h4">{{
            $i18n.t("headings.product") + " " + $i18n.t("headings.content")
          }}</span>
        </v-card-title>

        <v-row class="ma-0" v-if="!selectedProductContent.message">
          <div
            v-show="selectedProductContent.files.length > 0"
            style="width: 100%"
          >
            <v-card-title class="justify-center pb-0">
              <span class="text-h5">{{ $i18n.t("labels.files") }}</span>
            </v-card-title>
            <div class="pb-1" style="width: 100%">
              <v-col
                cols="12"
                v-for="(file, fileIndex) in selectedProductContent.files"
                :key="fileIndex"
              >
                <v-btn
                  color="primary"
                  @click="downloadFile(file.fileUrl)"
                  block
                  >{{ file.fileName }}</v-btn
                >
              </v-col>
            </div>
          </div>
          <div
            v-show="
              selectedProductContentURLS.normalLinks.length > 0 ||
              selectedProductContentURLS.videoEmbeds.length > 0
            "
            style="width: 100%"
            class="px-3 pb-2"
          >
            <div v-show="selectedProductContentURLS.videoEmbeds.length > 0">
              <v-card-title class="justify-center pb-3">
                <span class="text-h5">{{ $i18n.t("headings.videos") }}</span>
              </v-card-title>

              <div
                v-for="(
                  videoSrc, srcIndex
                ) in selectedProductContentURLS.videoEmbeds"
                :key="'video-' + srcIndex"
              >
                <VideoEmbed :src="videoSrc" aspect-ratio="1 / 1" />
              </div>
            </div>
            <!-- <div v-show="selectedProductContentURLS.normalLinks.length > 0">
              <v-card-title class="justify-center pb-1">
                <span class="text-h5">{{ $i18n.t("labels.urls") }}</span>
              </v-card-title>
              <ul>
                <li
                  v-for="(
                    url, urlIndex
                  ) in selectedProductContentURLS.normalLinks"
                  :key="'url-' + urlIndex"
                >
                  <a :href="url" target="_blank">{{ url }}</a>
                </li>
              </ul>
            </div> -->
          </div>

          <div
            v-if="
              selectedProductContent?.addons &&
              selectedProductContent.addons.length > 0
            "
            class="px-3"
            style="width: 100%"
          >
            <v-expansion-panels flat>
              <v-expansion-panel>
                <v-expansion-panel-header class="text-h5 pl-0">
                  {{ $i18n.t("labels.addons") }}
                </v-expansion-panel-header>
                <v-expansion-panel-content class="px-0">
                  <v-row no-gutters>
                    <v-col
                      v-for="(addon, index) in selectedProductContent.addons"
                      :key="index"
                      cols="12"
                      class="mb-4"
                    >
                      <v-card elevation="2" class="pa-3">
                        <v-card-title class="px-0 pb-2 pt-0">
                          {{ addon.title }} ({{ addon.type }})
                        </v-card-title>

                        <div
                          v-if="addon.fileUrl"
                          :class="addon.url ? 'mb-3' : ''"
                        >
                          <!-- <a :href="addon.fileUrl" download :target="_blank">{{
                            addon.fileName || "Download File"
                          }}</a> -->
                          <v-btn
                            color="primary"
                            @click="downloadFile(addon.fileUrl)"
                            block
                            >{{ addon.fileName }}</v-btn
                          >
                        </div>
                        <div v-if="addon.url">
                          <VideoEmbed
                            :src="addon.url"
                            :autoplay="false"
                            :controls="true"
                            :loop="false"
                            aspect-ratio="1 / 1"
                          />
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </v-row>

        <v-row v-else justify="center" no-gutters>
          {{ selectedProductContent.message }}
        </v-row>

        <v-card-actions class="pl-3">
          <v-btn
            color="secondary"
            class="black--text"
            @click="closeProductContentDialog"
            >{{ $i18n.t("actions.close") }}</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- AI Chat Dialog with vue-advanced-chat -->
    <v-dialog v-model="aiChatDialog" max-width="700px" persistent>
      <v-card class="chat-container">
        <v-toolbar flat dense class="py-1 mb-2">
          <v-toolbar-title
            >Chat about {{ selectedProduct?.title }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="
              aiChatDialog = false;
              chatHistory = [];
            "
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <vue-advanced-chat
          ref="aichat"
          :messages="JSON.stringify(chatMessages)"
          :rooms="JSON.stringify([{ roomId: 'ai-chat', users }])"
          :current-user-id="currentUserId"
          :current-room-id="'ai-chat'"
          single-room="true"
          avatars-visible="true"
          :messages-loaded="aiMessagesLoaded"
          rooms-loaded="true"
          show-files="false"
          show-audio="false"
          show-emojis="false"
          show-reaction-emojis="false"
          :message-actions="JSON.stringify([])"
          @send-message="sendAIQuestion"
          @edit-message="editChatMessage"
          @copy-message="copyChatMessage"
          height="600px"
        />
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      v-if="addonsDialog"
      v-model="addonsDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="justify-center">
          <span class="text-h4">Select Addons</span>
        </v-card-title>
        <v-container>
          <v-row class="mx-3 d-flex flex-column">
            <div cols="12" v-for="(addon, index) in productAddons" :key="index">
              <v-checkbox
                v-model="addon.selected"
                :label="`${addon.type} - ${addon.title} (R${
                  addon.price ? addon.price.toFixed(2) : ''
                })`"
              ></v-checkbox>
            </div>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-btn
            color="secondary"
            class="black--text"
            @click="closeAddonsDialog"
            >{{ $i18n.t("actions.cancel") }}</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="confirmAddons">{{
            $i18n.t("actions.confirm")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="sharedSnackbar"
      min-width="auto"
      top
      elevation="10"
      timeout="2000"
      rounded="pill"
      color="secondary"
    >
      <div class="text-center">Product URL copied!</div>
    </v-snackbar>
  </div>
</template>

<script>
import router from "@/router";
import { mapState } from "vuex";
import VideoEmbed from "@/components/global-components/VideoEmbed.vue";
import MediaGallery from "@/components/global-components/MediaGallery.vue";

import {
  DataStore,
  SortDirection,
  Storage,
  API,
  Predicates,
} from "aws-amplify";
import {
  Product,
  ProductTag,
  ProductCategory,
  // TeacherProductsOrder,
  ProductBundle,
} from "@/models";
import _ from "lodash";
import store from "@/store";
// import Helper from "@/components/global-components/Helper.vue";
import { reconfigureDatastore } from "@/plugins/datastore/config.js";
import * as mutations from "@/graphql/mutations";
import SimilarProductsCarousel from "@/components/global-components/SimilarProductsCarousel.vue";
import userAvatar from "@/assets/user-profile-img-blank.png";
import aiAvatar from "@/assets/juffrou-anri-animate-head.webp";
import {
  productBundlesByCategoryId,
  productsByCategoryId,
} from "@/graphql/queries";
import subjectAccessMixin from "@/mixins/subjectAccessMixin.js";

export default {  
  name: "TeacherProducts",
  mixins: [subjectAccessMixin],
  components: {
    VideoEmbed,
    SimilarProductsCarousel,
    MediaGallery,
    // ,Helper
  },
  data: () => ({
    sharedSnackbar: false,

    addonsDialog: false,
    productAddons: [],

    aiChatDialog: false,
    aiQuestion: "",
    chatHistory: [], // Store session-based chat history
    isStreaming: false,
    streamBuffer: "", // Buffer for streaming response
    aiMessagesLoaded: false,

    currentUserId: "user",
    users: [
      {
        _id: "user",
        username: "You",
        avatar: userAvatar,
      },
      {
        _id: "ai",
        username: "AI",
        avatar: aiAvatar,
      },
    ],

    initiallyLoaded: false,
    hoverIndex: null,

    // aiQuestion: '',
    // aiAnswer: '',
    // submittingAIQuestion: false,

    similarProductsPanel: null,
    hasSimilarProducts: false,
    similarProductsHeight: 0,

    showCartInSimilarProductsPanel: false,
    observeToolbarCart: null,

    currentDateTime: new Date().toISOString(),

    validQuestions: false,

    // productSubscription: null,
    syncedProductArray: [],
    syncedProductBundleArray: [],
    products: [],

    recommendedProducts: [],
    recommendedDiscounts: {},

    initialSmartItems: [],
    queryingAppsyncProducts: false,

    queriedProductsAndBundles: false,
    syncedProducts: false,
    syncedProductBundles: false,

    loadedProductThumbnails: [],
    savingProductToCart: false,

    syncedProductTagArray: [],
    // tagSubscription: null,

    syncedProductCategoryArray: [],
    // syncedSubscribedCategoryIDArray: [],
    // categorySubscription: null,
    routeCategory: null,
    routeCategoryArray: [],
    mainCategories: [],

    gettingProductContent: false,

    selectingProduct: false,
    selectedRouteProduct: false,
    selectedProduct: {
      id: "",
      title: "",
      description: "",
      price: 0,
      thumbnailImages: [],
      thumbnails: [],
      tags: [],
      questions: [],
      publishDate: "",
      physical: false,
      subscriptionProduct: false,
      eCommerceProduct: false,
    },
    buyingProduct: null,

    selectedProductContent: null,
    selectedProductDescriptionPanel: 0,

    productSelectDialog: false,
    productContentDialog: false,
    physicalQuestionsDialog: false,

    productsSearch: "",
    productsSearchTags: [],
    productsSearchCategories: [],
    viewMySubscribedProducts: false,
    viewMyBoughtProducts: false,
    viewMySchoolProducts: false,

    productsDataStoreLimit: 10,

    searchProductCategoriesMenu: false,

    formRules: {
      required: [(v) => !!v || "Required"],
    },
  }),

  computed: {
    ...mapState({
      offline: (state) => !state.isOnline,
      syncedTeacherProfile: (state) => state.syncedTeacherProfile,
      syncedTeacherProductsOrders: (state) => state.syncedTeacherProductsOrders,
      teacherProfilePayfastSubscriptionResponse: (state) =>
        state.teacherProfilePayfastSubscriptionResponse,

      syncedTeacherProfileModel: (state) => state.syncedTeacherProfileModel,
      syncedTeacherProductsOrderModels: (state) =>
        state.syncedTeacherProductsOrderModels,

      syncedPendingTeacherProductsOrder: (state) =>
        state.syncedPendingTeacherProductsOrder,

      syncedBoughtProducts: (state) => state.syncedBoughtProducts,
      syncedBoughtProductAddons: (state) => state.syncedBoughtProductAddons,
      syncedPendingProducts: (state) => state.syncedPendingProducts,

      teacherProfileID: (state) => state.teacherProfileID,
      userGroups: (state) => state.userGroups,
      userSignedIn: (state) => state.userSignedIn,
      datastorePredicates: (state) => state.datastorePredicates,
      changingDatastoreConfig: (state) => state.changingDatastoreConfig,
      datastoreReady: (state) => state.datastoreReady,
      startedDatastoreSync: (state) => state.startedDatastoreSync,
    }),

    // computedRecommendedProducts() {
    //   if (!this.selectedProduct || !this.selectedProduct.recommendations)
    //     return [];
    //   return this.selectedProduct.recommendations
    //     .map((rec) => {
    //       console.log("Processing recommendation:", rec);
    //       const prod = this.preloadedProductsAndSyncedArray.find(
    //         (p) => p.id === rec.productId && p.id !== this.selectedProduct.id
    //       );
    //       if (prod) {
    //         return { ...prod, recommendedDiscount: rec.discountPercentage };
    //       }
    //     })
    //     .filter(Boolean);
    // },

    recommendedDiscountMap() {
      const map = new Map();
      const orderProducts =
        this.syncedPendingTeacherProductsOrder?.orderProducts || [];
      orderProducts.forEach((op) => {
        let recs = op.recommendations;
        if (typeof recs === "string") recs = JSON.parse(recs);
        if (Array.isArray(recs)) {
          recs.forEach((rec) => {
            const discountPercentage =
              typeof rec.discountPercentage === "string"
                ? parseFloat(rec.discountPercentage)
                : rec.discountPercentage;

            if (rec.productId && discountPercentage > 0) {
              const current = map.get(rec.productId) || 0;
              map.set(rec.productId, Math.max(current, discountPercentage));
            }
          });
        }
      });
      return map;
    },

    computePreferredCatIds() {
      const smartSort = this.syncedTeacherProfileModel?.smartProductSort || {
        grades: [],
        categories: [],
      };
      return smartSort.categories;
    },

    chatMessages() {
      return this.chatHistory.map((msg, index) => ({
        _id: index.toString(), // Ensure unique ID as string
        content: msg.content,
        senderId: msg.role === "user" ? "user" : "ai",
        username: msg.role === "user" ? "You" : "AI",
        timestamp: new Date().toLocaleTimeString(),
        avatar: msg.avatar,
      }));
    },
    userOwnsProduct() {
      return (
        this.syncedBoughtProducts?.includes(this.selectedProduct.id) ||
        this.syncedTeacherProfileModel?.productSubscriptions?.some(
          (sub) => sub.productId === this.selectedProduct.id,
        )
      );
    },

    isDataFullySynced() {
      return this.syncedProducts && this.syncedProductBundles;
    },

    preloadedProductsAndSyncedArray() {
      const products = this.products;
      return [
        ...products,
        ...this.syncedProductArray.filter(
          (syncProd) => !products.some((prod) => prod.id === syncProd.id),
        ),
        ...this.syncedProductBundleArray.filter(
          (syncBundle) => !products.some((prod) => prod.id === syncBundle.id),
        ),
      ];
    },

    similarProducts() {
      const selectedP = this.selectedProduct;
      // console.log("Calculating similar products for:", selectedP);

      const recommended = this.recommendedProducts;
      const recommendedIds = new Set(
        recommended?.length > 0 ? recommended.map((p) => p.id) : [],
      );
      // console.log(
      //   "Recommended products:",
      //   recommended.map((p) => p.title)
      // );
      // console.log("Recommended productIds:", recommendedIds);

      const selectedCategoryId = selectedP.categoryId;
      const selectedCategory = this.syncedProductCategoryArray.find(
        (cat) => cat.id === selectedCategoryId,
      );

      let filterCategoryIds = this.collectCategoryIds(
        selectedCategory
          ? selectedCategory.parentId || selectedCategory.id
          : null,
      );

      // console.log(
      //   "Filter category IDs for similar products:",
      //   filterCategoryIds
      // );

      const orderedProductIdsSet = new Set(
        this.syncedTeacherProductsOrderModels
          ? this.syncedTeacherProductsOrderModels
              .filter((order) => order.orderStatus !== "CANCELLED")
              .flatMap(
                (order) =>
                  order.orderProducts?.map((product) => product.id) || [],
              )
          : [],
      );

      // console.log(
      //   "preloadedProductsAndSyncedArray length:",
      //   this.preloadedProductsAndSyncedArray.length
      // );
      // Existing logic for other similar products (based on category/tags, adjust as per your code)
      const otherSimilar = this.preloadedProductsAndSyncedArray.filter(
        (product) => {
          if (product.id === selectedP.id || recommendedIds.has(product.id)) {
            return false;
          }
          const sameCatOrSubCat = filterCategoryIds.some(
            (c) => product.categoryId === c,
          );
          // const sharedTags = product.tags?.some((tag) =>
          //   selectedP.tags?.includes(tag)
          // );

          return sameCatOrSubCat;
          //  || sharedTags;
        },
      );

      // Sort otherSimilar if needed (e.g., by title or publishDate)
      const sortedOther = _.sortBy(otherSimilar, [
        "publishDate",
        "title",
      ]).reverse();

      // filter and limit the similar products to display, ensuring we don't include products already in the user's cart and that have no thumbnail or aren't published yet
      const similarPs = _.cloneDeep([...recommended, ...sortedOther])
        .filter(
          (product) =>
            product.id !== selectedP.id &&
            product.thumbnails?.length > 0 &&
            product.publishDate <= this.currentDateTime &&
            !orderedProductIdsSet.has(product.id) &&
            !this.hasSchoolAccess(product.id),
        )
        .slice(0, 24);

      similarPs.forEach((p) => {
        const recDiscount = this.recommendedDiscountMap.get(p.id) || 0;
        const saleDiscount = p.discountPercentage || 0;
        // When the parent product is in the cart, the once-off recommended
        // discount is added on top of any active sale discount (e.g. 50% sale
        // + 10% recommendation = 60%), capped at 100% so the price never goes
        // negative.
        const combinedDiscount =
          recDiscount > 0
            ? Math.min(saleDiscount + recDiscount, 100)
            : saleDiscount;
        this.$set(p, "effectiveDiscount", combinedDiscount);
        this.$set(p, "isRecommendedDiscount", recDiscount > 0);
      });
      // this.applyDiscountsToProducts(similarPs);
      // similarPs.forEach((product) => {
      //   product.recommendedDiscount = this.recommendedDiscountMap[product.id];
      // });

      // console.log(
      //   "Final similar products list:",
      //   similarPs.map((p) => p.title)
      // );

      return similarPs;
    },

    pageTitle() {
      if (this.viewMySchoolProducts) {
        return this.$i18n.t("headings.schoolResources");
      }
      return (this.viewMySubscribedProducts || this.viewMyBoughtProducts) &&
        router.currentRoute.path.includes("products")
        ? this.$i18n.t("otherText.my") + " " + this.$i18n.t("headings.library")
        : this.viewMySubscribedProducts || this.viewMyBoughtProducts
        ? this.$i18n.t("otherText.my") + " " + this.$i18n.t("headings.library")
        : this.$i18n.t("headings.shopResources");
    },

    selectedProductContentURLS() {
      const urls =
        this.selectedProductContent?.urls?.length > 0
          ? this.selectedProductContent.urls
          : [];

      const youtubeRegex = /^[a-zA-Z0-9_-]{11}$/; // Matches YouTube video IDs (11-character alphanumeric)
      const vimeoRegex = /^[0-9]+$/; // Matches Vimeo video IDs (only numbers)

      const videoEmbeds = [];
      const normalLinks = [];

      urls.forEach((link) => {
        if (youtubeRegex.test(link) || vimeoRegex.test(link)) {
          videoEmbeds.push(link);
        } else {
          normalLinks.push(link);
        }
      });

      return { videoEmbeds, normalLinks };
    },

    // selectedProductPrice() {
    //   const p = this.selectedProduct;
    //   const disc =
    //     p.recommendedDiscount ||
    //     p.effectiveDiscount ||
    //     p.discountPercentage ||
    //     0;
    //   return this.productPrice(p.price, disc);
    // },

    selectedProductPrice() {
      const p = this.selectedProduct;
      return this.productPrice(
        p.price,
        p.effectiveDiscount || p.discountPercentage || 0,
      );
    },

    selectedProductVat() {
      return `Price incl. VAT (15%) ${Number.parseFloat(
        this.selectedProduct.price
          ? this.selectedProduct.price - this.selectedProduct.price / 1.15
          : 0,
      ).toFixed(2)}`;
    },

    screenWidth() {
      let width = this.$vuetify.breakpoint.width;
      return width;
    },

    routeCategoryChildren() {
      if (this.routeCategory) {
        return this.syncedProductCategoryArray.filter(
          (category) => category.parentId === this.routeCategory.id,
        );
      } else return [];
    },

    routeCategoryLinksTree() {
      if (this.routeCategory) {
        let category = this.routeCategory;
        let categoryLinks = [];
        while (category) {
          categoryLinks.unshift(category);
          category = this.syncedProductCategoryArray.find(
            (cat) => cat.id === category.parentId,
          );
        }
        return categoryLinks;
      } else return null;
    },

    categoryTree() {
      // Assuming syncedProductCategoryArray contains flat array of categories
      // with parentId indicating hierarchy, transform it into a tree-like structure
      return this.buildCategoryTree(this.syncedProductCategoryArray);
    },

    computedProductCategoryArray: {
      get: function () {
        return this.syncedProductCategoryArray.map((category) => {
          let parentCategories = [];

          if (category.parentId) {
            let currentCategory = category;
            while (currentCategory.parentId) {
              const parentCategory = this.syncedProductCategoryArray.find(
                (category) => category.id === currentCategory.parentId,
              );
              if (parentCategory) {
                parentCategories.unshift(parentCategory.name);
                currentCategory = parentCategory;
              } else {
                break;
              }
            }
          }

          return parentCategories.length > 0
            ? parentCategories.join("/") + "/" + category.name
            : category.name;
        });
      },
    },

    computedProductsSearchCategories: {
      get: function () {
        let categories = [];
        _.forEach(this.productsSearchCategories, (categoryId) => {
          const category = _.find(this.syncedProductCategoryArray, {
            id: categoryId,
          });
          if (category) {
            let parentCategories = [];

            if (category.parentId) {
              let currentCategory = category;
              while (currentCategory.parentId) {
                const parentCategory = this.syncedProductCategoryArray.find(
                  (category) => category.id === currentCategory.parentId,
                );
                if (parentCategory) {
                  parentCategories.unshift(parentCategory.name);
                  currentCategory = parentCategory;
                } else {
                  break;
                }
              }
            }

            categories.push(
              parentCategories.length > 0
                ? parentCategories.join("/") + "/" + category.name
                : category.name,
            );
          }
        });
        return categories;
      },
      // set: function (newValue) {
      //   let categoryIds = [];
      //   if (newValue.length > 0) {
      //     for (const category of newValue) {
      //       const categoryParts = category.split("/");
      //       const newCategory = categoryParts[categoryParts.length - 1];

      //       if (typeof newCategory === "string" && newCategory !== "") {
      //         const category = this.syncedProductCategoryArray.find(
      //           (category) => category.name === newCategory
      //         );

      //         if (category) categoryIds.push(category.id);
      //       }
      //     }

      //     this.productsSearchCategories = categoryIds;
      //   } else {
      //     this.productsSearchCategories = [];
      //   }
      // },
    },

    computedProductsSearchTags: {
      get: function () {
        let tags = [];
        _.forEach(this.productsSearchTags, (tagId) => {
          const productTag = _.find(this.syncedProductTagArray, { id: tagId });
          if (productTag) {
            tags.push(productTag);
          }
        });
        return tags;
      },
      set: function (newValue) {
        this.productsSearchTags = newValue;
      },
    },

    productExistsOnPendingOrder() {
      if (!this.selectedProduct) return false;

      const pendingTeacherProductsOrder =
        this.syncedPendingTeacherProductsOrder;

      if (!pendingTeacherProductsOrder) return false;

      const productOnPendingOrder = _.find(
        pendingTeacherProductsOrder.orderProducts,
        { id: this.selectedProduct.id },
      );

      return productOnPendingOrder ? true : false;
    },

    // Check if a product is bought or subscribed
    isProductBoughtOrSubscribed() {
      const { id } = this.selectedProduct;
      return this.syncedBoughtProducts?.includes(id) ||
        this.hasSchoolAccess(id) ||
        this.syncedTeacherProfileModel?.productSubscriptions?.some(
          (subscription) => subscription.productId === id,
        )
        ? true
        : false;
    },

    // Check if the product's download limit is reached
    productAddToMyLibrary() {
      const { id, subscriptionProduct } = this.selectedProduct;
      return subscriptionProduct &&
        !this.isProductBoughtOrSubscribed &&
        !this.downloadLimitReached(this.selectedProduct) &&
        this.subscribedToGrade(this.selectedProduct.categoryId) &&
        (this.teacherProfilePayfastSubscriptionResponse?.status_text ===
          "ACTIVE" ||
          this.teacherProfilePayfastSubscriptionResponse
            ?.subscriptionStillValid)
        ? true
        : false;
    },

    // Check if download limit for the product is reached
    productDownloadLimitReached() {
      const { id, subscriptionProduct } = this.selectedProduct;
      return subscriptionProduct &&
        !this.isProductBoughtOrSubscribed &&
        this.downloadLimitReached(this.selectedProduct)
        ? true
        : false;
    },

    // Check if subscription to grade is needed to download
    productSubToGradeToDownload() {
      const { id, subscriptionProduct, categoryId } = this.selectedProduct;
      return subscriptionProduct &&
        !this.isProductBoughtOrSubscribed &&
        !this.subscribedToGrade(categoryId)
        ? true
        : false;
    },

    // Check if content should be shown
    productShowContent() {
      return this.isProductBoughtOrSubscribed && !this.selectedProduct.products
        ? true
        : false;
    },

    // Check if bundle content should be shown
    productBundleShowContent() {
      return this.isProductBoughtOrSubscribed && this.selectedProduct.products
        ? true
        : false;
    },

    // Check if product can be subscribed
    productSubscribable() {
      return this.selectedProduct?.subscriptionProduct ? true : false;
    },

    // Check if the product is buyable
    productBuyable() {
      const {
        id,
        // , eCommerceProduct
      } = this.selectedProduct;
      return (
        // eCommerceProduct &&
        !this.productAddToMyLibrary && !this.isProductBoughtOrSubscribed
          ? true
          : false
      );
    },
  },

  mounted() {
    try {
      // console.log("mounted TeacherProducts");
      if (router.currentRoute.path.includes("school-resources")) {
        this.viewMySchoolProducts = true;
      } else if (router.currentRoute.path.includes("purchased-resources")) {
        this.viewMySubscribedProducts = true;
        this.viewMyBoughtProducts = true;
      } else if (router.currentRoute.path.includes("subscribed-products")) {
        this.viewMySubscribedProducts = true;
      } else if (router.currentRoute.path.includes("bought-products")) {
        this.viewMyBoughtProducts = true;
      }

      store.commit("changeDatastorePredicates", [
        {
          model: "Product",
          predicate: "Teacher",
        },
        {
          model: "ProductTag",
          predicate: "Teacher",
        },
        {
          model: "ProductCategory",
          predicate: "Teacher",
        },
        {
          model: "ProductBundle",
          predicate: "Teacher",
        },
      ]);

      if (!this.startedDatastoreSync || this.datastoreReady) {
        reconfigureDatastore();
      }

      // console.log(
      //   "TeacherProducts.vue mounted - changingDatastoreConfig:",
      //   this.changingDatastoreConfig,
      //   "teacherProfileID:",
      //   this.teacherProfileID ? "set" : "not set",
      // );

      if (!this.changingDatastoreConfig && this.teacherProfileID) {
        // if (router.currentRoute.params?.categoryId) {
        //   const categories = await DataStore.query(ProductCategory);

        //   const sortedItemsViaName = categories.sort((a, b) =>
        //     a.name.localeCompare(b.name)
        //   );

        //   this.syncedProductCategoryArray = sortedItemsViaName;

        //   this.mainCategories = sortedItemsViaName.filter(
        //     (category) => !category.parentId
        //   );

        //   await this.queryRouteCategory();
        // } else {
        //   console.log("mounted checkDataStoreConfig");
        //   await this.changeProductsSearchQuery();
        // }

        // this.computeRecommendedDiscounts();
        this.syncData();
      }
    } catch (error) {
      console.log(error);
    }
    // finally {
    //   if (!this.initiallyLoaded) {
    //     this.initiallyLoaded = true;
    //   }
    // }
  },

  watch: {
    // recommendedDiscountMap: {
    //   handler(newMap) {
    //     this.products.forEach((product) => {
    //       product.recommendedDiscount = newMap[product.id];
    //     });
    //   },
    //   deep: true,
    // },

    syncedPendingTeacherProductsOrder: {
      handler(newVal) {
        // this.computeRecommendedDiscounts();
        this.queryRecommendedProducts(this.selectedProduct);
        this.applyDiscountsToProducts(this.products);
        // this.applyDiscountsToProducts(this.similarProducts);
        this.applyDiscountsToProducts([this.selectedProduct]);
      },
      deep: true,
    },

    changingDatastoreConfig: {
      handler(newVal, oldVal) {
        // console.log(
        //   "TeacherProducts.vue watch - changingDatastoreConfig",
        //   newVal,
        //   oldVal,
        // );

        if (newVal === true) {
          return;
        }

        if (newVal === false) {
          // if (router.currentRoute.params?.categoryId) {
          //   console.log(
          //     "router.currentRoute.params?.categoryId:",
          //     router.currentRoute.params?.categoryId
          //   );
          //   const categories = await DataStore.query(ProductCategory);

          //   const sortedItemsViaName = categories.sort((a, b) =>
          //     a.name.localeCompare(b.name)
          //   );

          //   this.syncedProductCategoryArray = sortedItemsViaName;

          //   this.mainCategories = sortedItemsViaName.filter(
          //     (category) => !category.parentId
          //   );

          //   await this.queryRouteCategory();
          // } else {
          //   await this.changeProductsSearchQuery();
          // }

          this.syncData();
        }
      },
      // deep: true,
    },

    productSelectDialog(val) {
      if (val) {
        this.$nextTick(() => {
          this.setupIntersectionObserver();
        });
      } else {
        if (this.observeToolbarCart) {
          this.observeToolbarCart.disconnect();
          this.observeToolbarCart = null;
        }

        this.closeSelectProductDialog();
      }
    },

    syncedTeacherProductsOrders: {
      async handler(newVal) {
        const routeParams = router?.currentRoute?.params;
        if (
          !this.selectedRouteProduct &&
          routeParams &&
          typeof routeParams.productId === "string" &&
          routeParams.productId !== "" &&
          newVal &&
          !this.productSelectDialog &&
          !this.selectingProduct &&
          this.products?.length > 0 &&
          !this.initiallyLoaded
        ) {
          // console.log("selecting product: syncedTeacherProductsOrders");
          await this.selectProduct(routeParams.productId, true);

          if (
            typeof routeParams.action === "string" &&
            routeParams.action === "buy" &&
            this.productBuyable &&
            !this.productExistsOnPendingOrder &&
            !this.offline
          ) {
            // console.log("buying product");
            this.attemptBuyProduct();
          }
        }
      },
      immediate: true,
      deep: true,
    },

    "$route.params.categoryId": {
      handler() {
        // console.log("categoryId changed");
        this.queryRouteCategory();
      },
    },

    "$route.params.productId": {
      async handler() {
        console.log("productId changed");
        await this.changeProductsSearchQuery();
      },
    },

    subscriptionAccessProductIds: {
      async handler() {
        if (this.viewMySchoolProducts) {
          this.initialSmartItems = [];
          await this.changeProductsSearchQuery();
        }
      },
    },

    "$route.path": {
      async handler(newVal, oldVal) {
        console.log("path changed");

        if (newVal.includes("school-resources")) {
          this.viewMySchoolProducts = true;
          this.viewMySubscribedProducts = false;
          this.viewMyBoughtProducts = false;
          this.initialSmartItems = [];
          await this.changeProductsSearchQuery();
          return;
        }

        if (oldVal && oldVal.includes("school-resources")) {
          this.viewMySchoolProducts = false;
        }

        if (newVal.includes("purchased-resources")) {
          this.viewMySubscribedProducts = true;
          this.viewMyBoughtProducts = true;
          this.initialSmartItems = [];
          await this.changeProductsSearchQuery();
        } else if (
          oldVal &&
          (oldVal.includes("products") || oldVal.includes("bought-products")) &&
          newVal.includes("subscribed-products")
        ) {
          this.viewMySubscribedProducts = true;
          this.viewMyBoughtProducts = false;
          this.initialSmartItems = [];
          await this.changeProductsSearchQuery();
        } else if (
          oldVal &&
          (oldVal.includes("products") ||
            oldVal.includes("subscribed-products")) &&
          newVal.includes("bought-products")
        ) {
          this.viewMyBoughtProducts = true;
          this.viewMySubscribedProducts = false;
          this.initialSmartItems = [];
          await this.changeProductsSearchQuery();
        } else if (
          oldVal &&
          (oldVal.includes("subscribed-products") ||
            oldVal.includes("bought-products") ||
            oldVal.includes("purchased-resources")) &&
          newVal.includes("products")
        ) {
          this.viewMySubscribedProducts = false;
          this.viewMyBoughtProducts = false;
          await this.changeProductsSearchQuery();
        }
      },
    },

    syncedTeacherProfileModel: {
      handler() {
        if (
          this.initialSmartItems?.length === 0 &&
          !this.viewMyBoughtProducts &&
          !this.viewMySchoolProducts &&
          !this.queryingAppsyncProducts
        ) {
          // console.log("smartProductSort changed, querying initial smart items");
          this.queryInitialSmart();
        }
      },
    },
  },

  methods: {
    isOwnedProduct(id) {
      return this.syncedBoughtProducts?.includes(id) ||
        this.hasSchoolAccess(id) ||
        this.syncedTeacherProfileModel?.productSubscriptions?.some(
          (subscription) => subscription.productId === id,
        )
        ? true
        : false;
    },

    // computeDiscountMap() {
    //     const map = new Map();
    //     const orderProducts = this.syncedPendingTeacherProductsOrder?.orderProducts || [];
    //     orderProducts.forEach(op => {
    //       let recs = op.recommendations;
    //       if (typeof recs === 'string') recs = JSON.parse(recs);
    //       if (Array.isArray(recs)) {
    //         recs.forEach(rec => {
    //           if (rec.productId && rec.discountPercentage > 0) {
    //             const current = map.get(rec.productId) || 0;
    //             map.set(rec.productId, Math.max(current, rec.discountPercentage));
    //           }
    //         });
    //       }
    //     });
    //     return map;
    //   },

    applyDiscountsToProducts(products) {
      if (!Array.isArray(products)) return;
      products.forEach((p) => {
        const recDiscount = this.recommendedDiscountMap.get(p.id) || 0;
        const saleDiscount = p.discountPercentage || 0;
        // When the parent product is in the cart, the once-off recommended
        // discount is added on top of any active sale discount (e.g. 50% sale
        // + 10% recommendation = 60%), capped at 100% so the price never goes
        // negative.
        const combinedDiscount =
          recDiscount > 0
            ? Math.min(saleDiscount + recDiscount, 100)
            : saleDiscount;
        this.$set(p, "effectiveDiscount", combinedDiscount);
        this.$set(p, "isRecommendedDiscount", recDiscount > 0);
      });
    },

    isBundleCategory(categoryName) {
      if (!categoryName) return false;
      // console.log("Checking bundle category for:", categoryName.toLowerCase());
      const bundleCategories = ["bundle", "bundel"];
      // return bundleCategories.some((bC) => bC.includes(categoryName.toLowerCase()));
      return bundleCategories.some((sub) =>
        categoryName.toLowerCase().includes(sub),
      );
    },

    // async computeRecommendedDiscounts() {
    //   if (!this.syncedPendingTeacherProductsOrder) {
    //     this.recommendedDiscounts = {};
    //     return;
    //   }
    //   const cartProductIds =
    //     this.syncedPendingTeacherProductsOrder?.orderProducts?.length > 0
    //       ? this.syncedPendingTeacherProductsOrder.orderProducts.map(
    //           (p) => p.id
    //         )
    //       : [];
    //   const cartProducts = (
    //     await Promise.all(
    //       cartProductIds.map(async (id) => {
    //         let prod =
    //           this.syncedProductArray.find((p) => p.id === id) ||
    //           this.syncedProductBundleArray.find((p) => p.id === id);
    //         if (!prod) {
    //           prod =
    //             (await DataStore.query(Product, id).catch(() => null)) ||
    //             (await DataStore.query(ProductBundle, id).catch(() => null));
    //         }
    //         return prod;
    //       })
    //     )
    //   ).filter(Boolean);

    //   const discounts = {};
    //   cartProducts.forEach((cP) => {
    //     let recs = cP.recommendations;
    //     // console.log(
    //     //   "Processing recommendations for cart product:",
    //     //   cP.title,
    //     //   recs
    //     // );
    //     if (typeof recs === "string") recs = JSON.parse(recs);
    //     if (Array.isArray(recs)) {
    //       recs.forEach((rec) => {
    //         const recId = rec.productId;
    //         const disc =
    //           typeof rec.discountPercentage === "string"
    //             ? parseFloat(rec.discountPercentage)
    //             : rec.discountPercentage;
    //         if (disc && (!discounts[recId] || disc > discounts[recId])) {
    //           discounts[recId] = disc;
    //         }
    //       });
    //     }
    //   });
    //   this.recommendedDiscounts = discounts;
    //   // console.log("Computed recommended discounts:", this.recommendedDiscounts);
    // },

    // applyDiscountToProduct(product) {
    //   const recDisc = this.recommendedDiscounts[product.id];
    //   // console.log(
    //   //   `Applying discount to product ${product.title}: recommended discount = ${recDisc}, own discount = ${product.discountPercentage}`
    //   // );
    //   const ownDisc = product.discountPercentage || 0;
    //   if (recDisc && recDisc > ownDisc) {
    //     product.effectiveDiscount = recDisc;
    //     product.isRecommendedDiscount = true;
    //   } else {
    //     product.effectiveDiscount = ownDisc;
    //     product.isRecommendedDiscount = false;
    //   }
    // },

    async queryRecommendedProducts(similarProduct) {
      if (!similarProduct.recommendations) return [];
      const recommededProducts = (
        typeof similarProduct.recommendations === "string"
          ? JSON.parse(similarProduct.recommendations)
          : similarProduct.recommendations
      ).map(async (rec) => {
        // console.log("Processing recommendation:", rec);
        const prod =
          (await DataStore.query(Product, rec.productId).catch(() => null)) ||
          (await DataStore.query(ProductBundle, rec.productId).catch(
            () => null,
          ));

        // console.log("Queried product for recommendation:", prod);
        if (prod) {
          if (this.syncedBoughtProducts?.includes(similarProduct.id)) {
            return prod;
          } else
            return {
              ...prod,
              effectiveDiscount:
                typeof rec.discountPercentage === "string"
                  ? parseFloat(rec.discountPercentage)
                  : rec.discountPercentage,
            };
        }
      });

      const recommendedProductsResolved = _.cloneDeep(
        await Promise.all(recommededProducts),
      ).filter(Boolean);
      this.recommendedProducts = recommendedProductsResolved;
      // console.log("Final recommended products list:", this.recommendedProducts);
    },

    directBuyProduct(id) {
      const similarProd = this.similarProducts.find((p) => p.id === id);
      if (!similarProd) return;

      const clonedProd = _.cloneDeep(similarProd);
      clonedProd.discountPercentage =
        similarProd.effectiveDiscount ?? similarProd.discountPercentage ?? 0;

      this.buyingProduct = clonedProd;
      this.attemptBuyProduct();
    },

    hasAddons(addons) {
      return (
        (typeof addons === "string" ? JSON.parse(addons) : addons).length > 0
      );
    },

    // isProductNew(publishDate) {
    //   if (!publishDate) return false;
    //   const publish = new Date(publishDate);
    //   const now = new Date();
    //   const diffTime = Math.abs(now - publish);
    //   const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    //   return diffDays <= 28; // Consider new if published within the last 28 days
    // },

    isProductTaggedAs(tags, tagName) {
      if (!tags || tags.length === 0) return false;
      const targetTag = this.syncedProductTagArray.find(
        (tag) => tag.name.toLowerCase() === tagName.toLowerCase(),
      );
      if (!targetTag) return false;
      return tags.includes(targetTag.id);
    },

    closeAddonsDialog() {
      this.addonsDialog = false;
      this.productAddons = [];
      if (!this.buyingProduct) {
        this.selectedProduct.addons = _.cloneDeep(
          (
            this.syncedProductArray.find(
              (product) => product.id === this.selectedProduct.id,
            ) ||
            this.syncedProductBundleArray.find(
              (product) => product.id === this.selectedProduct.id,
            )
          ).addons || null,
        );
      }
      this.buyingProduct = null;
    },

    async confirmAddons() {
      const selectedAddons = this.productAddons
        .filter((addon) => addon.selected)
        .map(({ selected, ...addon }) => addon);
      const product = this.buyingProduct || this.selectedProduct;
      product.addons = selectedAddons;
      product.questions = !product.questions
        ? []
        : typeof product.questions === "string"
        ? JSON.parse(product.questions)
        : product.questions;

      this.addonsDialog = false;
      this.productAddons = [];
      if (product.questions && product.questions.length > 0) {
        this.physicalQuestionsDialog = true;
      } else {
        await this.buyProduct(product);
        if (this.buyingProduct) this.buyingProduct = null;
      }
    },

    getFilter(type) {
      const filter = { and: [] };
      filter.and.push({ publishDate: { lt: this.currentDateTime } });
      filter.and.push({ softDeleted: { ne: true } });
      const lowerSearch = this.productsSearch
        ? this.productsSearch.split(" ").map((s) => s.toLowerCase())
        : [];
      lowerSearch.forEach((s) =>
        filter.and.push({ searchField: { contains: s } }),
      );
      if (this.productsSearchTags.length) {
        filter.and.push({
          or: this.productsSearchTags.map((tag) => ({
            tags: { contains: tag },
          })),
        });
      }
      if (type === "Product") {
        filter.and.push({ eCommerceProduct: { eq: true } });
        // filter.and.push({ subscriptionProduct: { ne: true } });
      }
      return filter.and.length ? filter : null;
    },

    async queryInitialSmart() {
      this.queryingAppsyncProducts = true;

      const cats = this.computePreferredCatIds.filter((c) => {
        if (this.routeCategory && !this.routeCategoryArray.includes(c))
          return false;
        if (
          this.productsSearchCategories.length &&
          !this.productsSearchCategories.includes(c)
        )
          return false;
        return true;
      });

      // console.log('queryInitialSmart cats', cats);

      if (!cats.length) {
        this.initialSmartItems = [];
        this.queryingAppsyncProducts = false;
        return;
      }

      const productFilter = this.getFilter("Product");
      const bundleFilter = this.getFilter("Bundle");

      // Fire ALL Product + ALL Bundle queries at the same time
      const [productResponses, bundleResponses] = await Promise.all([
        Promise.all(
          cats.map(
            (cat) =>
              API.graphql({
                query: productsByCategoryId,
                variables: { categoryId: cat, filter: productFilter },
                authMode: "AMAZON_COGNITO_USER_POOLS",
              }).catch((err) => ({
                data: { productsByCategoryId: { items: [] } },
              })), // graceful fallback
          ),
        ),
        Promise.all(
          cats.map(
            (cat) =>
              API.graphql({
                query: productBundlesByCategoryId,
                variables: { categoryId: cat, filter: bundleFilter },
                authMode: "AMAZON_COGNITO_USER_POOLS",
              }).catch((err) => ({
                data: { productBundlesByCategoryId: { items: [] } },
              })), // graceful fallback
          ),
        ),
      ]);

      // Extract and filter products
      let allProducts = productResponses
        .flatMap((r) => r?.data?.productsByCategoryId?.items || [])
        .filter((p) => p.thumbnails && p.thumbnails.length > 0);

      // Extract and filter bundles
      let allBundles = bundleResponses
        .flatMap((r) => r?.data?.productBundlesByCategoryId?.items || [])
        .filter((p) => p.thumbnails && p.thumbnails.length > 0);

      // Parse bundle.products in one go (faster than looping later)
      allBundles.forEach((bundle) => {
        if (bundle.products) bundle.products = JSON.parse(bundle.products);
      });

      const combined = [...allProducts, ...allBundles];

      if (
        this.viewMySubscribedProducts ||
        this.viewMyBoughtProducts ||
        this.viewMySchoolProducts
      ) {
        this.queryingAppsyncProducts = false;
        return;
      }

      const smartItems = _.sortBy(combined, [
        (p) => p.featured || false,
        (p) => new Date(p.publishDate),
        (p) => p.title,
      ]).reverse();

      this.initialSmartItems = smartItems;

      const search = this.productsSearch ? this.productsSearch.split(" ") : [];
      const filteredSmartItems = this.filterSmartProducts(
        smartItems,
        search,
      ).slice(0, this.productsDataStoreLimit);

      if (filteredSmartItems.length > 0) {
        // Loop through queriedItems to update or add new products
        filteredSmartItems.forEach((newProduct) => {
          // console.log("newProduct.title:", newProduct.title);
          const existingProductIndex = this.products.findIndex(
            (product) => product.id === newProduct.id,
          );
          // console.log("existingProductIndex:", existingProductIndex);
          if (existingProductIndex !== -1) {
            const existingProduct = this.products[existingProductIndex];

            if (existingProduct.updatedAt !== newProduct.updatedAt) {
              // Update the product while preserving thumbnailImages
              const updatedProduct = {
                ...newProduct,
                thumbnailImages: existingProduct.thumbnailImages,
              };
              this.products.splice(existingProductIndex, 1, updatedProduct);
            }
          } else {
            // If new product doesn't exist in this.products, add it
            this.products.push({
              ...newProduct,
              thumbnailImages: [],
            });
          }
        });

        // Remove products not in sortedProducts
        this.products = this.products.filter((product) =>
          filteredSmartItems.some((newProduct) => newProduct.id === product.id),
        );

        if (filteredSmartItems.length < this.productsDataStoreLimit) {
          this.queryProductsAndBundles();
        }

        // console.log('this.products after smart sync:', this.products);
      }

      this.queryingAppsyncProducts = false;
    },

    computeScore(p) {
      const smartSort = this.syncedTeacherProfileModel?.smartProductSort;
      if (!smartSort) return 0;
      const preferredGrades = smartSort.grades || [];
      const preferredCategories = smartSort.categories || [];
      const category = _.find(this.syncedProductCategoryArray, {
        id: p.categoryId,
      });
      if (!category) return 0;
      const grade = category.grade;
      const gradeMatch = preferredGrades.includes(grade) ? 1 : 0;
      const catMatch = preferredCategories.includes(p.categoryId) ? 1 : 0;
      return gradeMatch + catMatch;
    },

    openAIChatDialog() {
      this.aiChatDialog = true;
      this.chatHistory = []; // Reset chat history for new session
      this.aiQuestion = "";
      this.streamBuffer = "";
      setTimeout(() => {
        this.aiMessagesLoaded = true;
        const chatContainer = document.querySelector("vue-advanced-chat");
        console.log("chatContainer", chatContainer);
        const shadowRoot = chatContainer.shadowRoot;
        if (shadowRoot) {
          const header = shadowRoot.querySelector(".vac-room-header");
          if (header) {
            header.style.display = "none";
          }

          const styleElement = document.createElement("style");
          styleElement.textContent = `
        .vac-message-box .vac-message-card { /* Adjust selectors based on inspection */
          font-size: 1.3rem !important; /* Set your desired font size */
        }
        .vac-container-scroll {
          margin-top: 0px !important;
        }
        .vac-message-wrapper .vac-avatar {
          height: 48px !important;
          width: 48px !important;
          min-height: 48px !important;
          min-width: 48px !important;
        }
      `;
          shadowRoot.appendChild(styleElement);
          // const messageCard = shadowRoot.querySelector('.vac-message-card');
          // if (messageCard) {
          //   messageCard.style.fontSize = '1.3rem';
          // }
        }
      }, 0);
    },

    async sendAIQuestion(obj) {
      const content = obj.detail[0].content;
      console.log("content", content);
      if (!content || !this.selectedProduct?.id) return;

      this.chatHistory.push({
        role: "user",
        content,
        senderId: "user",
        username: "You",
        avatar: userAvatar,
      });
      // this.isStreaming = true;
      this.aiMessagesLoaded = false;

      try {
        const response = await API.post("ailambdaapi", "/ai/query", {
          body: {
            productId: this.selectedProduct.id,
            question: content,
            chatHistory: this.chatHistory, // Include chat history for context
          },
        });

        // this.aiAnswer = response.answer || 'No answer received';

        const lastMessage = this.chatHistory[this.chatHistory.length - 1];
        if (lastMessage && lastMessage.role === "ai") {
          lastMessage.content = response.answer || "No answer received";
          lastMessage.senderId = "ai";
          lastMessage.username = "AI";
          lastMessage.avatar = aiAvatar;
        } else {
          this.chatHistory.push({
            role: "ai",
            content: response.answer || "No answer received",
            senderId: "ai",
            username: "AI",
            avatar: aiAvatar,
          });
        }

        // const response = await fetch(`https://3as2tr4etyqzd7aw66zjpearla0kmchj.lambda-url.eu-west-2.on.aws/ai/query`, {
        //   method: 'POST',
        //   headers: { 'Content-Type': 'application/json' },
        //   body: JSON.stringify({
        //     productId: this.selectedProduct.id,
        //     question: content,
        //     chatHistory: this.chatHistory, // Include chat history for context
        //   }),
        // });

        // if (!response.ok) {
        //   throw new Error(`HTTP error! status: ${response.status}`);
        // }

        // const reader = response.body.getReader();
        // const decoder = new TextDecoder();
        // let aiResponse = '';
        // const streaming = true;

        // while (streaming) {
        //   const { done, value } = await reader.read();
        //   if (done) break;

        //   const chunk = decoder.decode(value, { stream: true });
        //   const lines = chunk.split('\n\n');
        //   for (const line of lines) {
        //     if (line.startsWith('data: ')) {
        //       const data = JSON.parse(line.replace('data: ', ''));
        //       if (data.text) {
        //         aiResponse += data.text;
        //         // Update the last AI message or add a new one
        //         const lastMessage = this.chatHistory[this.chatHistory.length - 1];
        //         if (lastMessage && lastMessage.role === 'ai') {
        //           lastMessage.content = aiResponse;
        //         } else {
        //           this.chatHistory.push({ role: 'ai', content: aiResponse });
        //         }
        //         this.$forceUpdate(); // Force UI update for streaming
        //       } else if (data.error) {
        //         throw new Error(data.error);
        //       }
        //     }
        //   }
        // }
      } catch (error) {
        console.error("Error streaming AI response:", error);
        this.chatHistory.push({
          role: "ai",
          content: `Error: ${error.message}`,
          senderId: "ai",
          username: "AI",
          avatar: aiAvatar,
        });
      } finally {
        console.log("this.chatHistory", this.chatHistory);
        // this.isStreaming = false;
        setTimeout(() => {
          this.aiMessagesLoaded = true;
        }, 0);
        this.aiQuestion = "";
      }
    },

    editChatMessage({ messageId, newContent }) {
      const index = parseInt(messageId);
      if (this.chatHistory[index].role === "user") {
        this.chatHistory[index].content = newContent;
        // Optionally, re-send the edited message to the AI
        this.sendAIQuestion({ content: newContent });
      }
    },
    copyChatMessage({ message }) {
      navigator.clipboard
        .writeText(message.content)
        .then(() => {
          this.$vuetify.notify({
            text: "Copied to clipboard!",
            color: "success",
          });
        })
        .catch((err) => {
          console.error("Failed to copy:", err);
          this.$vuetify.notify({ text: "Failed to copy", color: "error" });
        });
    },

    async submitAIQuestion() {
      if (!this.aiQuestion || !this.userOwnsProduct) return;

      this.submittingAIQuestion = true;
      try {
        const response = await API.post("ailambdaapi", "/ai/query", {
          body: {
            productId: this.selectedProduct.id,
            question: this.aiQuestion,
          },
        });

        this.aiAnswer = response.answer || "No answer received";
      } catch (error) {
        console.error("Error submitting AI question:", error);
        this.aiAnswer = "Failed to get an answer. Please try again.";
      } finally {
        this.submittingAIQuestion = false;
        this.aiQuestion = ""; // Clear the input after submission
      }
    },

    splitString(str) {
      // Handle null or undefined by returning an empty array
      if (str == null) return [];
      return str.match(/\d+|\D+/g) || [];
    },

    compareParts(a, b) {
      // Handle null or undefined category names
      const safeA = (a || "").toLowerCase();
      const safeB = (b || "").toLowerCase();

      const partsA = this.splitString(safeA);
      const partsB = this.splitString(safeB);
      const len = Math.min(partsA.length, partsB.length);

      // Early return if both are empty
      if (partsA.length === 0 && partsB.length === 0) return 0;

      // Check if either string contains "Graad R" or "Grade R" (case-insensitive)
      const isGradeR_A = safeA.includes("graad r") || safeA.includes("grade r");
      const isGradeR_B = safeB.includes("graad r") || safeB.includes("grade r");

      // Check if either string contains a numbered grade (e.g., "Graad 1" or "Grade 1")
      const hasNumber_A = partsA.some((part) => /\d/.test(part));
      const hasNumber_B = partsB.some((part) => /\d/.test(part));

      // If one is "Grade R" and the other is a numbered grade, sort "Grade R" first
      if (isGradeR_A && hasNumber_B) return -1;
      if (isGradeR_B && hasNumber_A) return 1;

      // If neither is "Grade R" or both are, proceed with natural sorting
      for (let i = 0; i < len; i++) {
        const partA = partsA[i] || "";
        const partB = partsB[i] || "";
        if (/\d/.test(partA) && /\d/.test(partB)) {
          const numA = parseInt(partA, 10);
          const numB = parseInt(partB, 10);
          if (numA !== numB) {
            return numA - numB;
          }
        } else {
          const strA = partA.toLowerCase();
          const strB = partB.toLowerCase();
          if (strA < strB) return -1;
          if (strA > strB) return 1;
        }
      }
      return partsA.length - partsB.length;
    },

    setupIntersectionObserver() {
      if (this.$refs.toolbar && this.$refs.toolbar.$el) {
        this.observeToolbarCart = new IntersectionObserver(
          (entries) => {
            const toolbarEntry = entries[0];
            this.showCartInSimilarProductsPanel = !toolbarEntry.isIntersecting;
          },
          {
            root: null, // Observe relative to the viewport
            threshold: 0.1, // Trigger when 10% of the toolbar is visible
          },
        );
        this.observeToolbarCart.observe(this.$refs.toolbar.$el);
      }
    },

    changeSimilarProductsPanel() {
      this.$nextTick(() => {
        if (typeof this.similarProductsPanel !== "undefined") {
          this.selectedProductDescriptionPanel = null;
          this.similarProductsHeight = 336;

          const content = this.$refs.similarProductsPanelRef?.$el;
          if (content) {
            // Listen for the transition to complete, then scroll
            content.addEventListener(
              "transitionend",
              () => this.scrollToSimilarProducts(),
              { once: true }, // Ensures the listener runs only once
            );
          } else {
            // Fallback if ref is unavailable
            this.scrollToSimilarProducts();
          }
        } else {
          this.similarProductsHeight = 48;
        }
      });
    },

    changeProductDescriptionPanel() {
      this.$nextTick(() => {
        if (typeof this.selectedProductDescriptionPanel !== "undefined") {
          this.similarProductsPanel = null;
          this.similarProductsHeight = 48;
        }
      });
    },

    setHasSimilarProducts(value) {
      this.hasSimilarProducts = value;
      if (this.similarProductsHeight === 0) this.similarProductsHeight = 48;
    },

    scrollToSimilarProducts() {
      const container = this.$refs.productDialogDiv;
      if (container) {
        this.$vuetify.goTo(container.scrollHeight, {
          container: container,
          duration: 690,
          offset: 0,
          easing: "easeInOutCubic",
        });
      } else {
        console.error("Dialog div reference not found");
      }
    },

    slugify(text) {
      return text
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-|-$/g, "");
    },

    generateSeoId(productTitle, productCategory) {
      try {
        if (!productCategory) {
          console.warn("Category not found for product");
          return this.slugify(productTitle || "untitled");
        }

        // Build category slug hierarchy
        let categorySlugs = [
          productCategory.slug || this.slugify(productCategory.name),
        ];
        let currentCategory = productCategory;
        while (currentCategory.parentId) {
          const parentCategory = this.syncedProductCategoryArray.find(
            (cat) => cat.id === currentCategory.parentId,
          );
          if (!parentCategory) break;
          categorySlugs.unshift(
            parentCategory.slug || this.slugify(parentCategory.name),
          );
          currentCategory = parentCategory;
        }

        // Combine category slugs and product title
        const seoIdParts = [
          ...categorySlugs,
          this.slugify(productTitle || "untitled"),
        ];
        return seoIdParts.join("-");
      } catch (error) {
        console.error("Error generating seoId:", error);
        return "";
      }
    },

    shareProduct(product) {
      console.log("product:", product);

      const productCategory =
        this.syncedProductCategoryArray.find(
          (cat) => cat.id === product.categoryId,
        ) || null;

      const seoId = `product/${this.generateSeoId(
        product.title,
        productCategory,
      )}`;

      if (!seoId) return;

      const shareUrl = `${window.location.origin}/${seoId}`;

      // Use the Web Share API to share a message, image, and URL
      if (navigator.share) {
        navigator
          .share({
            // title: heading,
            // text: message,
            url: shareUrl,
          })
          .then(() => {
            // console.log("Shared successfully.")
          })
          .catch(() => {
            // console.error("Error sharing:", error)
          });

        // Use the Clipboard API to copy the custom string to the clipboard
        navigator.clipboard.writeText(shareUrl).catch(() => {
          // console.error('Error copying to clipboard:', error);
        });
      } else {
        // Use the Clipboard API to copy the custom string to the clipboard
        navigator.clipboard.writeText(shareUrl).catch(() => {
          // console.error('Error copying to clipboard:', error);
        });
      }

      this.sharedSnackbar = true;
    },

    async viewBundleProduct(bundleProductId) {
      await this.closeSelectProductDialog();

      this.selectProduct(bundleProductId);
    },

    async checkDataStoreConfig() {
      try {
        const search = this.productsSearch
          ? this.productsSearch.split(" ")
          : [];

        const existingProductPVariables = this.datastorePredicates.find(
          (item) => item.model === "Product",
        )?.predicateVariables;

        const productPVariables = {
          // syncedSubscribedCategoryIDArray: this.syncedSubscribedCategoryIDArray,
          viewMySubscribedProducts: this.viewMySubscribedProducts,
          // syncedTeacherProfileModel: this.syncedTeacherProfileModel,
          viewMyBoughtProducts: this.viewMyBoughtProducts,
          // syncedBoughtProducts: this.syncedBoughtProducts,
          showFeatured: this.showFeatured,
          productsSearchTags: this.productsSearchTags,
          routeCategory: this.routeCategory,
          routeCategoryArray: this.routeCategoryArray,
          productsSearchCategories: this.productsSearchCategories,
          search: search,
          currentDateTime: this.currentDateTime,
        };

        if (
          !existingProductPVariables ||
          JSON.stringify(existingProductPVariables) !==
            JSON.stringify(productPVariables)
        ) {
          store.commit("changingDatastoreConfig", true);

          console.log("changing predicate - reconfigureDatastore");
          store.commit("changeDatastorePredicate", {
            model: "Product",
            predicate: "Teacher",
            predicateVariables: productPVariables,
          });

          await reconfigureDatastore();
        } else {
          console.log("No need to change predicate");

          this.syncData();
        }

        return true;
      } catch (error) {
        console.log(error);

        return false;
      }
    },

    productPrice(price, discountPercentage) {
      // console.log("price:", price, "discountPercentage:", discountPercentage);
      return price && discountPercentage
        ? `<del>R${(price || 0).toFixed(2)}</del> R` +
            ((price || 0) - (price || 0) * (discountPercentage / 100)).toFixed(2)
        : (price || 0).toFixed(2)
        ? "R" + (price || 0).toFixed(2)
        : "FREE";
    },

    openCartDialog() {
      this.$emit("openCloseCartDialog");
    },

    async changeProductsSearchQuery() {
      this.productsDataStoreLimit = 10;
      try {
        // await this.checkDataStoreConfig();
        await this.queryProductsAndBundles();
      } catch (error) {
        console.log("checkDataStoreConfig error: ", error);
      }
    },

    copyPlaceholderToValue(question) {
      if (!question.value && question.placeholder) {
        question.value = question.placeholder;
      }
    },

    attemptBuyProduct() {
      const product = this.buyingProduct || this.selectedProduct;
      // console.log("product.addons", product.addons);
      // console.log("typeof product.addons", typeof product.addons);

      const addons = !product.addons
        ? []
        : typeof product.addons === "string"
        ? JSON.parse(product.addons)
        : product.addons;

      product.questions = !product.questions
        ? []
        : typeof product.questions === "string"
        ? JSON.parse(product.questions)
        : product.questions;

      if (addons && addons.length > 0) {
        this.productAddons = addons.map((addon) => ({
          ...addon,
          selected: false,
        }));
        // console.log("productAddons", this.productAddons);
        this.addonsDialog = true;
      } else if (product.questions && product.questions.length > 0) {
        this.physicalQuestionsDialog = true;
      } else {
        this.buyProduct(product);
      }
    },

    async addToCart() {
      const product = this.buyingProduct || this.selectedProduct;
      try {
        await this.buyProduct(product);
        if (this.buyingProduct) this.buyingProduct = null;
      } catch (error) {
        console.log(error);
      }
      this.physicalQuestionsDialog = false;
    },

    generateOrderID() {
      const now = new Date();
      const year = now.getFullYear().toString().slice(-2); // Get last 2 digits of year
      const month = (now.getMonth() + 1).toString().padStart(2, "0");
      const day = now.getDate().toString().padStart(2, "0");
      const hour = now.getHours().toString().padStart(2, "0");
      const minute = now.getMinutes().toString().padStart(2, "0");
      const second = now.getSeconds().toString().padStart(2, "0");
      const millisecond = Math.floor(now.getMilliseconds() / 10)
        .toString()
        .padStart(2, "0");
      return `${year}${month}${day}-${hour}${minute}${second}${millisecond}`;
    },

    async buyProduct(product) {
      this.savingProductToCart = true;

      // const queriedItems = await DataStore.query(TeacherProductsOrder, (item) =>
      //   item.orderStatus("eq", "PENDING")
      // );
      // // console.log("queriedItems", queriedItems);

      // const pendingTeacherProductsOrder = _.find(queriedItems, {
      //   orderStatus: "PENDING",
      // });

      const pendingTeacherProductsOrder =
        this.syncedPendingTeacherProductsOrder;

      // console.log(
      //   "pendingTeacherProductsOrder._version:",
      //   pendingTeacherProductsOrder._version
      // );
      // console.log("pendingTeacherProductsOrder", pendingTeacherProductsOrder);

      const newProduct = _.cloneDeep(product);
      // Record the product's own sale discount and the recommended (once-off)
      // portion separately, so the cart can later strip just the recommended
      // part if the recommending parent is removed. The recommended portion is
      // the discount the products currently in the cart grant this product.
      const recommendedDiscount =
        this.recommendedDiscountMap.get(product.id) || 0;
      const combinedDiscount =
        newProduct.effectiveDiscount != null
          ? Number(newProduct.effectiveDiscount) || 0
          : Number(newProduct.discountPercentage) || 0;
      newProduct.recommendedDiscount = recommendedDiscount;
      newProduct.baseDiscountPercentage = Math.max(
        combinedDiscount - recommendedDiscount,
        0,
      );
      newProduct.discountPercentage = combinedDiscount;
      newProduct.isRecommendedDiscount = recommendedDiscount > 0;

      if (newProduct.thumbnailImages) delete newProduct.thumbnailImages;
      if (newProduct.searchField) delete newProduct.searchField;
      if (newProduct.description) delete newProduct.description;
      if (newProduct.displayItems) delete newProduct.displayItems;
      if (newProduct.createdAt) delete newProduct.createdAt;
      if (newProduct.updatedAt) delete newProduct.updatedAt;
      if (newProduct.featured) delete newProduct.featured;
      if (newProduct.thumbnails) delete newProduct.thumbnails;
      if (newProduct.type) delete newProduct.type;
      if (newProduct.videoPreview) delete newProduct.videoPreview;
      if (newProduct._lastChangedAt) delete newProduct._lastChangedAt;
      if (newProduct.__typename) delete newProduct.__typename;

      // console.log("newProduct", newProduct);

      if (pendingTeacherProductsOrder) {
        if (
          pendingTeacherProductsOrder.orderProducts?.some(
            (p) => p.id === product.id,
          )
        ) {
          console.log("Product already added to the pending order.");
          this.savingProductToCart = false;
          return;
        }

        const newProductsOrderArray =
          pendingTeacherProductsOrder.orderProducts?.length > 0
            ? [...pendingTeacherProductsOrder.orderProducts, newProduct]
            : [newProduct];

        const uniqueProducts = _.uniqBy(newProductsOrderArray, "id");

        // await DataStore.save(
        //   TeacherProductsOrder.copyOf(
        //     pendingTeacherProductsOrder,
        //     (updateModel) => {
        //       updateModel.orderProducts = uniqueProducts;
        //     }
        //   )
        // );

        const teacherProductsOrderDetails = {
          id: pendingTeacherProductsOrder.id,
          _version: pendingTeacherProductsOrder._version, // add the "_version" field if your AppSync API has conflict detection (required for DataStore) enabled
          orderProducts: JSON.stringify(uniqueProducts),
          updatedAtMonth: new Date().toISOString().slice(0, 7),
        };
        // console.log("teacherProductsOrderDetails", teacherProductsOrderDetails);

        const updatedTPO = await API.graphql({
          query: mutations.updateTeacherProductsOrder,
          variables: {
            input: teacherProductsOrderDetails,
          },
          authMode: "AMAZON_COGNITO_USER_POOLS",
        }).catch((error) => {
          // console.log("error:", error);
        });

        // console.log("updatedTPO:", updatedTPO);

        if (updatedTPO?.data?.updateTeacherProductsOrder) {
          store.commit("storePendingTeacherProductsOrder", {
            ...updatedTPO.data.updateTeacherProductsOrder,
            orderProducts: uniqueProducts,
          });
        }
      } else {
        // await DataStore.save(
        //   new TeacherProductsOrder({
        //     orderProducts: [newProduct],
        //     orderStatus: "PENDING",
        //     teacherprofileID: this.teacherProfileID,
        //   })
        // );

        const newOrderID = this.generateOrderID();
        const newOrderMonth = new Date().toISOString().slice(0, 7);

        const teacherProductsOrderDetails = {
          orderProducts: JSON.stringify([newProduct]),
          orderStatus: "PENDING",
          orderID: newOrderID,
          teacherprofileID: this.teacherProfileID,
          createdAtMonth: newOrderMonth,
          updatedAtMonth: newOrderMonth,
        };

        const newTPO = await API.graphql({
          query: mutations.createTeacherProductsOrder,
          variables: {
            input: teacherProductsOrderDetails,
          },
          authMode: "AMAZON_COGNITO_USER_POOLS",
        }).catch((error) => {
          console.log("error:", error);
        });

        // console.log("newTPO:", newTPO);

        if (newTPO?.data?.createTeacherProductsOrder) {
          store.commit("storePendingTeacherProductsOrder", {
            ...newTPO.data.createTeacherProductsOrder,
            orderProducts: [newProduct],
          });
        }
      }

      if (this.hasSimilarProducts) {
        this.selectedProductDescriptionPanel = null;
        this.similarProductsPanel = 0;
        this.changeSimilarProductsPanel();
      }

      this.savingProductToCart = false;
    },

    subscribedToGrade(selectedProductCategoryId) {
      if (!selectedProductCategoryId) return false;
      if (
        this.syncedTeacherProfileModel?.payfastSubscriptionPackage
          ?.grandFathered &&
        this.teacherProfilePayfastSubscriptionResponse?.subscriptionStillValid
      )
        return true;

      try {
        const currentCategory = this.syncedProductCategoryArray.find(
          (category) => category.id === selectedProductCategoryId,
        );
        if (!currentCategory) {
          // console.error("Category not found.");
          return false;
        }

        // Get the array of grades from the synced teacher profile model
        const grades =
          this.syncedTeacherProfileModel.payfastSubscriptionPackage.grades;

        if (!currentCategory.grade && grades?.length > 0) {
          return true;
        }

        // Check if the top parent category's grade matches any in the grades array
        return grades.includes(currentCategory.grade);
      } catch (error) {
        // console.error("Error in subscribedToGrade method:", error);
        return false;
      }
    },

    currentMonthLimit() {
      return (
        this.$i18n.t("products.currentMonthLimit") +
        new Date().toLocaleString("default", { month: "long" })
      );
    },

    downloadLimitReached(selectedProduct) {
      if (
        (this.syncedTeacherProfileModel?.payfastSubscriptionPackage
          ?.grandFathered &&
          this.teacherProfilePayfastSubscriptionResponse
            ?.subscriptionStillValid) ||
        !this.syncedTeacherProfileModel?.payfastSubscriptionPackage ||
        this.syncedTeacherProfileModel?.payfastSubscriptionPackage?.limit === -1
      )
        return false;

      const now = new Date();
      const currentYear = now.getFullYear();
      const currentMonth = now.getMonth();

      const foundCategory = _.find(this.syncedProductCategoryArray, {
        id: selectedProduct.categoryId,
      });

      if (!foundCategory || !foundCategory.grade) return false;

      // Filter the subscriptions that match the given grade and have a timestamp within the current month
      const downloadsThisMonth =
        this.syncedTeacherProfileModel?.productSubscriptions?.filter(
          (subscription) => {
            if (
              !subscription.grade ||
              subscription.grade !== foundCategory.grade
            ) {
              return false;
            }

            const timestampDate = new Date(subscription.timeStamp);
            return (
              timestampDate.getFullYear() === currentYear &&
              timestampDate.getMonth() === currentMonth
            );
          },
        );

      // console.log("downloadsThisMonth.length", downloadsThisMonth?.length);
      // console.log(
      //   "limit",
      //   this.syncedTeacherProfileModel.payfastSubscriptionPackage.limit
      // );

      return (
        downloadsThisMonth?.length >=
        this.syncedTeacherProfileModel.payfastSubscriptionPackage.limit
      );
    },

    changeRouteCategory(categoryId) {
      this.productsSearchCategories = [];

      const currentRoutePath = router.currentRoute.path;

      if (!currentRoutePath.includes(categoryId)) {
        router.push(
          currentRoutePath.includes("products")
            ? `/app/products/category/${categoryId}`
            : currentRoutePath.includes("school-resources")
            ? `/app/school-resources/category/${categoryId}`
            : currentRoutePath.includes("purchased-resources")
            ? `/app/purchased-resources/category/${categoryId}`
            : currentRoutePath.includes("subscribed-products")
            ? `/app/subscribed-products/category/${categoryId}`
            : `/app/bought-products/category/${categoryId}`,
        );
      }
    },

    changeProductsSearchCategories() {
      this.routeCategory = null;
      this.routeCategoryArray = [];
      this.changeProductsSearchQuery();
    },

    routeCategoriesHome() {
      if (router.currentRoute.params?.categoryId) {
        this.productsSearchCategories = [];
        router.push(
          router.currentRoute.path.includes("products")
            ? "/app/products"
            : router.currentRoute.path.includes("school-resources")
            ? "/app/school-resources"
            : router.currentRoute.path.includes("purchased-resources")
            ? "/app/purchased-resources"
            : router.currentRoute.path.includes("subscribed-products")
            ? "/app/subscribed-products"
            : "/app/bought-products",
        );
        this.routeCategory = null;
        this.routeCategoryArray = [];
        this.changeProductsSearchQuery();
      }
    },

    async loadThumbnail(entries, productId) {
      // console.log("entries:", entries);

      // Find the product using the productId
      const product = this.products.find((p) => p.id === productId);

      if (
        product &&
        !product.thumbnailImages.length &&
        product.thumbnails?.length
      ) {
        try {
          // Load up to two thumbnails
          const maxThumbnails = Math.min(product.thumbnails.length, 2);
          for (let i = 0; i < maxThumbnails; i++) {
            const thumbnailImgSrc = await Storage.get(product.thumbnails[i], {
              level: "public",
            });
            this.$set(product.thumbnailImages, i, thumbnailImgSrc);
          }
        } catch (error) {
          console.log("Error loading thumbnail:", error);
        }
      }
    },

    isImageLoaded(productId, thumbnailImages) {
      return thumbnailImages && thumbnailImages.length > 0;
    },

    // isImageLoaded(productId, thumbnailImages) {
    //   if (this.loadedProductThumbnails.includes(productId)) return true;

    //   if (thumbnailImages.length === 0) return false;
    //   const img = new Image();
    //   img.onload = () => {
    //     this.loadedProductThumbnails.push(productId);
    //     return true;
    //   };
    //   img.onerror = () => {
    //     return false;
    //   };
    //   img.src = thumbnailImages[0];
    //   return false;
    // },

    toggleMenu() {
      this.searchProductCategoriesMenu = !this.searchProductCategoriesMenu;
    },

    buildCategoryTree(categories) {
      let tree = [];

      // Create a map of categories by their ID for quicker access
      const categoryMap = {};
      categories.forEach((category) => {
        categoryMap[category.id] = { ...category, children: [] };
      });

      // Function to recursively build the tree
      const buildTree = (categoryId) => {
        const category = categoryMap[categoryId];
        if (!category) return null; // Return null if category not found

        // Recursively build children
        if (category.parentId) {
          const parentCategory = categoryMap[category.parentId];
          if (parentCategory) {
            parentCategory.children.push(category);
          }
        } else {
          tree.push(category); // Add to top-level tree if no parent
        }
      };

      // Build tree for each category
      categories.forEach((category) => {
        buildTree(category.id);
      });

      return tree;
    },

    computeSelectedProductCategory() {
      let parentCategories = [];
      if (
        this.selectedProduct.categoryId &&
        this.selectedProduct.categoryId !== ""
      ) {
        let firstCategoryId = this.selectedProduct.categoryId;

        let category = this.syncedProductCategoryArray.find(
          (category) => category.id === firstCategoryId,
        );

        if (!category) return "";

        if (category.parentId) {
          let currentCategory = category;
          while (currentCategory.parentId) {
            const parentCategory = this.syncedProductCategoryArray.find(
              (category) => category.id === currentCategory.parentId,
            );
            if (parentCategory) {
              parentCategories.unshift(parentCategory.name);
              currentCategory = parentCategory;
            } else {
              break;
            }
          }
        }

        return parentCategories.length > 0
          ? parentCategories.join(" / ") + " / " + category.name
          : category.name;
      } else return "";
    },

    computeSelectedProductTags() {
      let tagNames = [];
      if (this.selectedProduct.tags.length > 0) {
        this.selectedProduct.tags.forEach((tagId) => {
          const tag = this.syncedProductTagArray.find(
            (tag) => tag.id === tagId,
          );
          if (tag) {
            tagNames.push(tag.name);
          }
        });
        return tagNames.length > 0 ? tagNames.join(", ") : "";
      } else return "";
    },

    mouseOverProductThumbnail(productId) {
      this.hoverIndex = productId;
    },

    mouseOutProductThumbnail(productId) {
      this.hoverIndex = null;
    },

    closeSelectProductDialog() {
      try {
        // console.log("Closing product select dialog...");
        this.selectedProduct = _.cloneDeep({
          id: "",
          title: "",
          description: "",
          price: 0,
          thumbnailImages: [],
          thumbnails: [],
          tags: [],
          questions: [],
          publishDate: "",
          physical: false,
          subscriptionProduct: false,
          eCommerceProduct: false,
        });

        this.selectedProductImgHoveringIndex = -1;
        this.selectedProductThumbnailIndex = 0;
        this.selectedProductContent = null;
        this.similarProductsPanel = null;
        this.productSelectDialog = false;
        this.recommendedProducts = [];
        this.buyingProduct = null;
      } catch (error) {
        console.log(error);
      }
    },

    closePhysicalQuestionsDialog() {
      this.physicalQuestionsDialog = false;
      this.validQuestions = false;
      this.closeAddonsDialog();
      this.buyingProduct = null;
    },

    closeProductContentDialog() {
      this.productContentDialog = false;
    },

    showProductContentDialog() {
      this.productContentDialog = true;
    },

    downloadFile(fileUrl) {
      window.open(fileUrl, "_blank");
    },

    async getVimeoThumbnail(videoId) {
      try {
        const response = await fetch(
          `https://vimeo.com/api/oembed.json?url=https://vimeo.com/${videoId}`,
        );
        const data = await response.json();
        return data.thumbnail_url;
      } catch (error) {
        console.error("Error fetching Vimeo thumbnail:", error);
        return null;
      }
    },

    getYouTubeThumbnail(videoId) {
      return `https://img.youtube.com/vi/${videoId}/0.jpg`;
    },

    async selectProduct(productID, routeProduct) {
      if (this.selectingProduct) return;

      try {
        this.selectingProduct = true;

        this.similarProductsPanel = null;
        let newlySelectedProduct = null;

        if (!this.initiallyLoaded) {
          this.initiallyLoaded = true;
          newlySelectedProduct =
            this.products.find((product) => product.id === productID) ||
            _.cloneDeep(
              this.syncedProductArray.find(
                (product) => product.id === productID,
              ) ||
                this.syncedProductBundleArray.find(
                  (product) => product.id === productID,
                ) ||
                (await DataStore.query(Product, productID).catch(() => null)) ||
                (await DataStore.query(ProductBundle, productID).catch(
                  () => null,
                )),
            );
        } else {
          newlySelectedProduct =
            this.products.find((product) => product.id === productID) ||
            _.cloneDeep(
              this.syncedProductArray.find(
                (product) => product.id === productID,
              ) ||
                this.syncedProductBundleArray.find(
                  (product) => product.id === productID,
                ) ||
                (await DataStore.query(Product, productID).catch(() => null)) ||
                (await DataStore.query(ProductBundle, productID).catch(
                  () => null,
                )),
            );
        }

        if (!newlySelectedProduct) {
          console.log("Product not found.");
          return;
        }

        this.queryRecommendedProducts(newlySelectedProduct);
        // this.applyDiscountToProduct(newlySelectedProduct);

        this.applyDiscountsToProducts([newlySelectedProduct]);
        // this.applyDiscountsToProducts(this.similarProducts);

        if (newlySelectedProduct.thumbnails?.length > 0) {
          const existingThumbnailsCount =
            newlySelectedProduct.thumbnailImages?.length || 0;
          const thumbnailsToLoad = newlySelectedProduct.thumbnails.slice(
            existingThumbnailsCount,
          );
          const additionalThumbnails = await Promise.all(
            thumbnailsToLoad.map(
              async (thumbnailKey) =>
                await Storage.get(thumbnailKey, { level: "public" }),
            ),
          );

          if (newlySelectedProduct.thumbnailImages) {
            newlySelectedProduct.thumbnailImages = [
              ...newlySelectedProduct.thumbnailImages,
              ...additionalThumbnails,
            ];
          } else {
            newlySelectedProduct.thumbnailImages = [...additionalThumbnails];
          }
        }

        newlySelectedProduct.displayItems = [];
        if (newlySelectedProduct.thumbnailImages.length > 0) {
          newlySelectedProduct.displayItems =
            newlySelectedProduct.thumbnailImages.map((src, index) => ({
              type: "image",
              src,
            }));
        }

        if (newlySelectedProduct.videoPreview) {
          const platform = /^[0-9]+$/.test(newlySelectedProduct.videoPreview)
            ? "vimeo"
            : "youtube";
          let thumbnailUrl;
          if (platform === "youtube") {
            thumbnailUrl = this.getYouTubeThumbnail(
              newlySelectedProduct.videoPreview,
            );
          } else if (platform === "vimeo") {
            thumbnailUrl = await this.getVimeoThumbnail(
              newlySelectedProduct.videoPreview,
            );
          }
          if (thumbnailUrl) {
            newlySelectedProduct.displayItems.push({
              type: "video",
              src: newlySelectedProduct.videoPreview,
              thumbnail: thumbnailUrl,
            });
          }
        }

        this.selectedProduct = _.cloneDeep(newlySelectedProduct);
        this.productSelectDialog = true;
        this.selectedProductDescriptionPanel = 0;

        if (newlySelectedProduct.products) {
          return;
        }

        if (
          this.syncedTeacherProfileModel?.productSubscriptions?.some(
            (subscription) => subscription.productId === productID,
          )
        ) {
          this.saveGetProductContent();
        } else if (this.syncedBoughtProducts?.some((id) => id === productID)) {
          this.getProductContent();
        } else if (this.hasSchoolAccess(productID)) {
          this.getProductContent();
        }

        if (routeProduct) {
          this.selectedRouteProduct = true;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.selectingProduct = false;
      }
    },

    async saveGetProductContent() {
      this.gettingProductContent = true;
      // const ownsProduct = this.syncedTeacherProfileModel.products?.includes(
      //   this.selectedProduct.id
      // );

      const ownsProduct =
        this.syncedTeacherProfileModel.productSubscriptions?.some(
          (subscription) => subscription.productId === this.selectedProduct.id,
        );

      if (ownsProduct) {
        await this.getProductContent();
      } else if (
        this.teacherProfilePayfastSubscriptionResponse?.status_text ===
          "ACTIVE" ||
        this.teacherProfilePayfastSubscriptionResponse?.subscriptionStillValid
      ) {
        await this.saveProductContent();
      }

      this.gettingProductContent = false;
    },

    async saveProductContent() {
      try {
        // const productIds = this.syncedTeacherProfileModel.products
        //   ? [
        //       ...this.syncedTeacherProfileModel.products,
        //       this.selectedProduct.id,
        //     ]
        //   : [this.selectedProduct.id];

        const foundCategory = _.find(this.syncedProductCategoryArray, {
          id: this.selectedProduct.categoryId,
        });

        let objToPush = {
          productId: this.selectedProduct.id,
          timeStamp: new Date().toISOString(),
        };

        if (foundCategory?.grade > "") {
          objToPush.grade = foundCategory.grade;
        }

        const productSubscriptions = this.syncedTeacherProfileModel
          .productSubscriptions
          ? [
              ...new Set([
                ...this.syncedTeacherProfileModel.productSubscriptions,
                objToPush,
              ]),
            ]
          : [objToPush];

        await API.graphql({
          query: mutations.updateTeacherProfile,
          variables: {
            input: {
              id: this.syncedTeacherProfileModel.id,
              _version: this.syncedTeacherProfileModel._version,
              productSubscriptions: JSON.stringify(productSubscriptions),
            },
          },
          authMode: "AMAZON_COGNITO_USER_POOLS",
        });

        // await DataStore.save(
        //   TeacherProfile.copyOf(
        //     this.syncedTeacherProfileModel,
        //     (updateModel) => {
        //       updateModel.productSubscriptions = productSubscriptions;
        //     },
        //   ),
        // );

        // const teacherProfileDetails = {
        //   id: this.syncedTeacherProfileModel.id,
        //   _version: this.syncedTeacherProfileModel._version, // add the "_version" field if your AppSync API has conflict detection (required for DataStore) enabled
        //   productSubscriptions: JSON.stringify(productSubscriptions),
        // };
        // console.log("teacherProfileDetails", teacherProfileDetails);
        // const updatedTP = await API.graphql({
        //   query: mutations.updateTeacherProfile,
        //   variables: {
        //     input: teacherProfileDetails,
        //   },
        //   authMode: "AMAZON_COGNITO_USER_POOLS",
        // }).catch((error) => {
        //   console.log("error:", error);
        // });
        // console.log("updatedTP", updatedTP);

        await this.getProductContent();
      } catch (error) {
        console.log(error);
      }
    },

    async getProductContent() {
      try {
        this.gettingProductContent = true;

        const currentProductId = this.selectedProduct.id;

        const boughtProductAddons =
          this.syncedBoughtProductAddons?.find(
            (obj) => obj.productId === currentProductId,
          )?.addons ?? [];

        // console.log("Getting product content...");
        await API.get("productcontentapi", "/item", {
          queryStringParameters: {
            productID: currentProductId,
            addons: boughtProductAddons
              ? JSON.stringify(boughtProductAddons)
              : null,
          },
          // headers: {
          //   "Content-Type": "application/json",
          //   "Access-Control-Allow-Origin": "*",
          // },
        })
          .then(async (response) => {
            if (
              // !this.isProductBoughtOrSubscribed
              currentProductId !== this.selectedProduct.id
            ) {
              // console.log("Newly selected product not bought or subscribed.");
              // console.log("Old productId", currentProductId);
              // console.log("New ProductId", this.selectedProduct.id);

              this.gettingProductContent = false;
              return;
            }

            if (
              response.error ||
              (response.data?.files?.length === 0 &&
                response.data?.urls?.length === 0 &&
                response.data?.addons?.length === 0)
            ) {
              this.selectedProductContent = {
                message: this.$i18n.t("products.noContent"),
              };
            } else {
              this.selectedProductContent = _.cloneDeep(response.data);
            }

            this.gettingProductContent = false;
          })
          .catch((error) => {
            console.log(error);
            this.gettingProductContent = false;
          });
      } catch (error) {
        console.log(error);
        this.gettingProductContent = false;
      }
    },

    async loadMore() {
      this.productsDataStoreLimit += 10;
      this.queryProductsAndBundles();
    },

    filterSmartProducts(smartItems, search) {
      return smartItems.filter((product) => {
        // console.log(`Checking product: ${product.id}`); // Log start for each product

        // Helper arrays (pre-compute once outside if possible)
        const subscribedIds =
          this.syncedTeacherProfileModel?.productSubscriptions?.map(
            (ps) => ps.productId,
          ) || [];

        const boughtIds = this.syncedBoughtProducts || [];
        
        const schoolIds = this.subscriptionAccessProductIds || [];

        // 2. OR of two big AND blocks
        const isECommerceBlock = product.eCommerceProduct === true;
        // (the commented category ne() part is ignored as requested)

        const isSubscriptionBlock =
          product.subscriptionProduct === true &&
          (this.viewMySubscribedProducts
            ? subscribedIds.length > 0
              ? subscribedIds.includes(product.id) // OR of id eq each subscription
              : product.id === null // impossible → false
            : product.subscriptionProduct !== true); // i.e. false → block fails

        if (
          !product.products &&
          !this.viewMySchoolProducts &&
          !(isECommerceBlock || isSubscriptionBlock)
        ) {
          return false;
        }

        // 3. thumbnails > []  →  array with at least one element
        if (
          !Array.isArray(product.thumbnails) ||
          product.thumbnails.length === 0
        ) {
          // console.log(`Product ${product.id} failed thumbnails check. thumbnails: ${JSON.stringify(product.thumbnails)}`);
          return false;
        }

        // 4. publishDate < currentDateTime
        if (!(product.publishDate < this.currentDateTime)) {
          // console.log(`Product ${product.id} failed publishDate check. publishDate: ${product.publishDate}, currentDateTime: ${this.currentDateTime}`);
          return false;
        }

        // 5. OR: tags contains at least one of productsSearchTags
        const matchesSearchTags =
          this.productsSearchTags.length === 0 ||
          (Array.isArray(product.tags) &&
            this.productsSearchTags.some((tag) => product.tags.includes(tag)));
        if (!matchesSearchTags) {
          // console.log(`Product ${product.id} failed search tags check. productsSearchTags: ${JSON.stringify(this.productsSearchTags)}, product.tags: ${JSON.stringify(product.tags)}`);
          return false;
        }

        // 6. Conditional route category: if routeCategory → at least one categoryId match
        if (
          this.routeCategory &&
          !(
            Array.isArray(this.routeCategoryArray) &&
            this.routeCategoryArray.some((id) => product.categoryId === id)
          )
        ) {
          // console.log(`Product ${product.id} failed route category check. routeCategory: ${this.routeCategory}, routeCategoryArray: ${JSON.stringify(this.routeCategoryArray)}, product.categoryId: ${product.categoryId}`);
          return false;
        }

        // 7. OR: categoryId equals any in productsSearchCategories
        const matchesSearchCategories =
          this.productsSearchCategories.length === 0 ||
          this.productsSearchCategories.some((id) => product.categoryId === id);
        if (!matchesSearchCategories) {
          // console.log(`Product ${product.id} failed search categories check. productsSearchCategories: ${JSON.stringify(this.productsSearchCategories)}, product.categoryId: ${product.categoryId}`);
          return false;
        }

        // 8. EVERY search term (lowercased) is contained in searchField
        const searchFieldLower = (product.searchField || "").toLowerCase();
        const matchesAllSearchTerms = search
          .map((s) => s.toLowerCase())
          .every((term) => searchFieldLower.includes(term));
        if (!matchesAllSearchTerms) {
          // console.log(`Product ${product.id} failed search terms check. search: ${JSON.stringify(search)}, searchField: ${product.searchField}`);
          return false;
        }

        // 9. Final OR block: subscribed OR bought logic
        const subscribedCondition = this.viewMySubscribedProducts
          ? subscribedIds.length > 0
            ? subscribedIds.includes(product.id)
            : product.id === null
          : true;

        const boughtCondition = this.viewMyBoughtProducts
          ? boughtIds.length > 0
            ? boughtIds.includes(product.id)
            : product.id === null
          : true;

        if (!(subscribedCondition || boughtCondition)) {
          // console.log(`Product ${product.id} failed subscribed or bought condition check. subscribedCondition: ${subscribedCondition}, boughtCondition: ${boughtCondition}, viewMySubscribedProducts: ${this.viewMySubscribedProducts}, viewMyBoughtProducts: ${this.viewMyBoughtProducts}`);
          return false;
        }

        // 10. School-package view: only items unlocked by SubscriptionAccess
        if (this.viewMySchoolProducts && !schoolIds.includes(product.id)) {
          return false;
        }

        // All conditions passed
        // console.log(`Product ${product.id} passed all checks.`);
        return true;
      });
    },

    async queryProductsAndBundles() {
      try {
        if (
          this.initialSmartItems?.length === 0 &&
          !this.viewMyBoughtProducts &&
          !this.viewMySchoolProducts &&
          !this.queryingAppsyncProducts
        ) {
          await this.queryInitialSmart();
        } else if (
          this.viewMySubscribedProducts ||
          this.viewMyBoughtProducts ||
          this.viewMySchoolProducts
        ) {
          this.initialSmartItems = [];
        }

        const smartItems = this.initialSmartItems;
        // console.log("smartItems:", smartItems);

        const search = this.productsSearch
          ? this.productsSearch.split(" ")
          : [];

        const filteredSmartItems = this.filterSmartProducts(smartItems, search);
        const smartIds = filteredSmartItems.map((i) => i.id);
        // console.log("smartIds:", smartIds);
        const smartLength = filteredSmartItems.length;
        let regularLimit = this.productsDataStoreLimit - smartLength;
        let queriedProducts = [];
        let queriedProductBundles = [];
        const schoolIds = this.subscriptionAccessProductIds || [];
        if (regularLimit > 0) {
          // console.log("Querying products...");

          // const currentDateTime = new Date().toISOString();

          // await this.checkDataStoreConfig();

          queriedProducts = await DataStore.query(
            Product,
            (product) =>
              product.and((f) => [
                ...smartIds.map((id) => f.id("ne", id)),
                this.viewMySchoolProducts
                  ? true
                  : f.or((f) => [
                      f.and((f) => [f.eCommerceProduct("eq", true)]),
                      f.and((f) => [
                        f.subscriptionProduct("eq", true),
                        this.viewMySubscribedProducts
                          ? this.syncedTeacherProfileModel?.productSubscriptions
                              ?.length > 0
                            ? f.or((f) =>
                                this.syncedTeacherProfileModel.productSubscriptions.map(
                                  (pS) => f.id("eq", pS.productId),
                                ),
                              )
                            : f.id("eq", null)
                          : f.subscriptionProduct("ne", true),
                      ]),
                    ]),
                f.thumbnails("gt", []),
                f.publishDate("lt", this.currentDateTime),
                f.or((f) =>
                  this.productsSearchTags.map((tag) => f.tags("contains", tag)),
                ),
                this.routeCategory
                  ? f.or((f) =>
                      this.routeCategoryArray.map((id) =>
                        f.categoryId("eq", id),
                      ),
                    )
                  : true,
                f.or((f) =>
                  this.productsSearchCategories.map((id) =>
                    f.categoryId("eq", id),
                  ),
                ),
                search
                  .map((str) => str.toLowerCase())
                  .every((string) => f.searchField("contains", string)),

                f.or((f) => [
                  this.viewMySubscribedProducts
                    ? this.syncedTeacherProfileModel?.productSubscriptions
                        ?.length > 0
                      ? f.or(
                          (f) =>
                            this.syncedTeacherProfileModel.productSubscriptions.map(
                              (pS) => f.id("eq", pS.productId),
                            ),
                          // .reduce(
                          //   (c, pS) => c.id("eq", pS.productId),
                          //   f
                          // )
                        )
                      : f.id("eq", null)
                    : true,

                  this.viewMyBoughtProducts
                    ? this.syncedBoughtProducts?.length > 0
                      ? f.or(
                          (f) =>
                            this.syncedBoughtProducts.map((id) =>
                              f.id("eq", id),
                            ),
                          // .reduce(
                          //   (c, pS) => c.id("eq", pS),
                          //   f
                          // )
                        )
                      : f.id("eq", null)
                    : true,
                ]),

                  this.viewMySchoolProducts
                  ? schoolIds.length > 0
                    ? f.or((f) => schoolIds.map((id) => f.id("eq", id)))
                    : f.id("eq", null)
                  : true,
              ]),
            {
              limit: regularLimit,
              sort: (s) =>
                s
                  .featured(SortDirection.DESCENDING)
                  .publishDate(SortDirection.DESCENDING)
                  .title(SortDirection.DESCENDING),
            },
          );

          queriedProductBundles = await DataStore.query(
            ProductBundle,
            (product) =>
              product.and((f) => [
                ...smartIds.map((id) => f.id("ne", id)),
                this.viewMySubscribedProducts &&
                !this.viewMyBoughtProducts &&
                !this.viewMySchoolProducts
                  ? f.id("eq", null)
                  : true,

                this.viewMySchoolProducts
                  ? schoolIds.length > 0
                    ? f.or((f) => schoolIds.map((id) => f.id("eq", id)))
                    : f.id("eq", null)
                  : true,

                f.thumbnails("gt", []),
                f.publishDate("lt", this.currentDateTime),
                search
                  .map((str) => str.toLowerCase())
                  .every((string) => f.searchField("contains", string)),

                this.viewMyBoughtProducts
                  ? this.syncedBoughtProducts?.length > 0
                    ? f.or((f) =>
                        this.syncedBoughtProducts.reduce(
                          (c, pS) => c.id("eq", pS),
                          f,
                        ),
                      )
                    : f.id("eq", null)
                  : true,

                this.showFeatured ? f.featured("eq", true) : true,
                this.productsSearchTags.some((tag) => f.tags("contains", tag)),
                this.routeCategory
                  ? f.or((f) =>
                      this.routeCategoryArray.reduce(
                        (c, id) => c.categoryId("eq", id),
                        f,
                      ),
                    )
                  : true,
                f.or((f) =>
                  this.productsSearchCategories.reduce(
                    (c, id) => c.categoryId("eq", id),
                    f,
                  ),
                ),
              ]),
            {
              limit: regularLimit,
              sort: (s) =>
                s
                  .featured(SortDirection.DESCENDING)
                  .publishDate(SortDirection.DESCENDING)
                  .title(SortDirection.DESCENDING),
            },
          );
        }

        const queriedItems = [...queriedProducts, ...queriedProductBundles];
        const fullItems = [...filteredSmartItems, ...queriedItems]
          // softDeleted products/bundles are hidden from the grid unless the
          // teacher owns them (bought or subscribed). Owned ones stay visible
          // (incl. the bought/library view). Recommendations + bundle internals
          // are unaffected because they resolve from the synced arrays/DataStore.
          .filter((p) => !p.softDeleted || this.isOwnedProduct(p.id))
          .slice(0, this.productsDataStoreLimit);

        //  console.log("Queried products:", queriedProducts);

        // this.syncedProductArray = queriedProducts;

        // const mutableProducts = _.cloneDeep(queriedProducts);

        // // Remove products not in mutableProducts
        // this.products = this.products.filter((product) =>
        //   mutableProducts.some(
        //     (mutableProduct) =>
        //       mutableProduct.id === product.id &&
        //       mutableProduct.updatedAt === product.updatedAt
        //   )
        // );

        // mutableProducts.forEach(async (newProduct, newProductIndex) => {
        //   const existingProductIndex = this.products.findIndex(
        //     (existingProduct) =>
        //       existingProduct &&
        //       existingProduct.id === newProduct.id &&
        //       existingProduct.updatedAt === newProduct.updatedAt
        //   );

        //   if (existingProductIndex === -1) {
        //     if (newProduct.thumbnails.length > 0) {
        //       newProduct.thumbnailImages = [];
        //       for (
        //         let i = 0;
        //         i < Math.min(newProduct.thumbnails.length, 2);
        //         i++
        //       ) {
        //         const thumbnailKey = newProduct.thumbnails[i];
        //         const thumbnailImgSrc = await Storage.get(thumbnailKey, {
        //           level: "public",
        //         });

        //         // Save Thumbnail images
        //         const img = new Image();
        //         img.onload = function () {
        //           newProduct.thumbnailImages.push(thumbnailImgSrc);
        //         };
        //         img.onerror = function (error) {
        //           console.error("Error loading thumbnail image:", error);
        //         };
        //         img.src = thumbnailImgSrc;
        //       }
        //     }
        //   } else {
        //     const existingProduct = this.products.find(
        //       (storedProduct) =>
        //         storedProduct && storedProduct.id === newProduct.id
        //     );

        //     mutableProducts.splice(newProductIndex, 1, existingProduct);
        //   }
        // });

        // this.products = mutableProducts;

        // Loop through queriedItems to update or add new products
        fullItems.forEach((newProduct) => {
          // console.log("newProduct.title:", newProduct.title);
          const existingProductIndex = this.products.findIndex(
            (product) => product.id === newProduct.id,
          );
          // console.log("existingProductIndex:", existingProductIndex);
          if (existingProductIndex !== -1) {
            const existingProduct = this.products[existingProductIndex];

            if (existingProduct.updatedAt !== newProduct.updatedAt) {
              // Update the product while preserving thumbnailImages
              const updatedProduct = {
                ...newProduct,
                thumbnailImages: existingProduct.thumbnailImages,
              };
              this.products.splice(existingProductIndex, 1, updatedProduct);
            }
          } else {
            // If new product doesn't exist in this.products, add it
            this.products.push({
              ...newProduct,
              thumbnailImages: [],
            });
          }
        });

        // // Remove products not in sortedProducts
        this.products = this.products.filter((product) =>
          fullItems.some((newProduct) => newProduct.id === product.id),
        );

        // this.products.forEach((p) => this.applyDiscountToProduct(p));

        // const discountMap = this.computeDiscountMap();
        this.applyDiscountsToProducts(this.products);

        // console.log("this.products titles:", this.products.map(p => p.title));

        // this.products = _.sortBy(this.products, [
        //   (p) => p.featured || false,
        //   (p) => new Date(p.publishDate),
        //   (p) => p.title,
        // ]).reverse();

        const routeParams = router?.currentRoute?.params;

        if (
          !this.selectedRouteProduct &&
          routeParams &&
          typeof routeParams.productId === "string" &&
          routeParams.productId !== "" &&
          // !this.queriedProductsAndBundles &&
          this.syncedTeacherProductsOrders &&
          !this.selectingProduct &&
          !this.productSelectDialog
        ) {
          // console.log("selecting product: queryProducts");
          await this.selectProduct(routeParams.productId, true);

          if (
            typeof routeParams.action === "string" &&
            routeParams.action === "buy" &&
            this.productBuyable &&
            !this.productExistsOnPendingOrder
          ) {
            // console.log("buying product");
            this.attemptBuyProduct();
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.queriedProductsAndBundles = true;
      }
    },

    async queryRouteCategory() {
      if (!router.currentRoute.params?.categoryId) return;

      // const regex =
      //   /^category\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

      // if (!regex.test(router.currentRoute.params.category)) {
      //   router.push({ name: "NotFound" });
      //   return;
      // }
      // const routeCategoryParts =
      //   router.currentRoute.params?.category.split("/");

      // Extract the last part
      // const routeCategoryId = routeCategoryParts[routeCategoryParts.length - 1];
      const routeCategoryId = router.currentRoute.params?.categoryId;

      const routeCategory = _.find(this.syncedProductCategoryArray, {
        id: routeCategoryId,
      });

      if (routeCategory) {
        this.routeCategory = routeCategory;

        this.routeCategoryArray = this.collectCategoryIds(routeCategoryId);
      }

      await this.changeProductsSearchQuery();
    },

    // Helper function to recursively collect category IDs
    collectCategoryIds(categoryId) {
      let ids = [];

      // Helper function to traverse categories
      function traverseCategories(currentId) {
        // Add the current category ID to the list
        ids.push(currentId);
        // Find all children whose parentId matches currentId
        const children = this.syncedProductCategoryArray.filter(
          (cat) => cat.parentId === currentId,
        );
        // Recursively traverse each child
        children.forEach((child) => traverseCategories.call(this, child.id));
      }

      traverseCategories.call(this, categoryId);

      return ids;
    },

    syncData() {
      // console.log("Syncing data...TeacherProducts");
      try {
        this.syncProducts();
        this.syncProductBundles();

        const tagSubscription = DataStore.observeQuery(ProductTag).subscribe(
          (snapshot) => {
            const { isSynced, items } = snapshot;
            if (
              // isSynced &&
              items?.length > 0
            ) {
              this.syncedProductTagArray = items;
            }
          },
          // (error) => {
          //   console.log("tagSubscription error: ", error);
          // }
        );

        const categorySubscription = DataStore.observeQuery(
          ProductCategory,
        ).subscribe(
          (snapshot) => {
            const { isSynced, items } = snapshot;
            if (
              // isSynced &&
              items?.length > 0 &&
              items !== this.syncedProductCategoryArray
            ) {
              const sortedItemsViaName = items
                .filter((c) => c.name)
                .sort((a, b) => this.compareParts(a.name, b.name));

              this.syncedProductCategoryArray = sortedItemsViaName;

              this.mainCategories = sortedItemsViaName.filter(
                (category) => !category.parentId,
              );

              if (router.currentRoute.params?.categoryId) {
                this.queryRouteCategory();
              }

              //HIDE-subscription-17Jan2025-----------------------------------------------

              // const validGrades =
              //   this.syncedTeacherProfileModel?.payfastSubscriptionPackage
              //     ?.grades || [];

              // // Filter subjects where the grade is included in the validGrades array
              // const filteredCategories = items.filter((category) =>
              //   validGrades.includes(category.grade)
              // );

              // // Map the filtered subjects to their ids
              // const categoryIds = items.map((category) => category.id);

              // this.syncedSubscribedCategoryIDArray = categoryIds;

              //HIDE-subscription-17Jan2025-END-------------------------------------------
            }
          },
          // (error) => {
          //   console.log("categorySubscription error: ", error);
          // }
        );

        store.commit("addSubscriptions", [
          { model: "ProductTag", sub: tagSubscription },
          {
            model: "ProductCategory",
            sub: categorySubscription,
          },
        ]);
      } catch (error) {
        console.log("TeacherProducts syncData error:", error);
      }
    },

    syncProducts() {
      // const search = this.productsSearch ? this.productsSearch.split(" ") : [];

      const productSubscription = DataStore.observeQuery(
        Product,
        Predicates.ALL,
        // (product) =>
        //   product.and((f) => [
        //     f.or((f) => [
        //       f.and((f) => [
        //         f.eCommerceProduct("eq", true),
        //         //HIDE-subscription-17Dec2024

        //         // this.syncedSubscribedCategoryIDArray.map((id) =>
        //         //   f.categoryId("ne", id)
        //         // ),
        //       ]),
        //       f.and((f) => [
        //         f.subscriptionProduct("eq", true),
        //         this.viewMySubscribedProducts
        //           ? this.syncedTeacherProfileModel?.productSubscriptions
        //               ?.length > 0
        //             ? f.or((f) =>
        //                 this.syncedTeacherProfileModel.productSubscriptions.map(
        //                   (pS) => f.id("eq", pS.productId)
        //                 )
        //               )
        //             : f.id("eq", null)
        //           : f.subscriptionProduct("ne", true),
        //       ]),
        //     ]),
        //     f.thumbnails("gt", []),
        //     f.publishDate("lt", this.currentDateTime),
        //     f.or((f) =>
        //       this.productsSearchTags.map((tag) => f.tags("contains", tag))
        //     ),
        //     this.routeCategory
        //       ? f.or((f) =>
        //           this.routeCategoryArray.map((id) => f.categoryId("eq", id))
        //         )
        //       : true,
        //     f.or((f) =>
        //       this.productsSearchCategories.map((id) => f.categoryId("eq", id))
        //     ),
        //     search
        //       .map((str) => str.toLowerCase())
        //       .every((string) => f.searchField("contains", string)),

        //     f.or((f) => [
        //       this.viewMySubscribedProducts
        //         ? this.syncedTeacherProfileModel?.productSubscriptions?.length >
        //           0
        //           ? f.or(
        //               (f) =>
        //                 this.syncedTeacherProfileModel.productSubscriptions.map(
        //                   (pS) => f.id("eq", pS.productId)
        //                 )
        //               // .reduce(
        //               //   (c, pS) => c.id("eq", pS.productId),
        //               //   f
        //               // )
        //             )
        //           : f.id("eq", null)
        //         : true,

        //       this.viewMyBoughtProducts
        //         ? this.syncedBoughtProducts?.length > 0
        //           ? f.or(
        //               (f) =>
        //                 this.syncedBoughtProducts.map((id) => f.id("eq", id))
        //               // .reduce(
        //               //   (c, pS) => c.id("eq", pS),
        //               //   f
        //               // )
        //             )
        //           : f.id("eq", null)
        //         : true,
        //     ]),
        //   ]),
        {
          sort: (s) =>
            s
              .featured(SortDirection.DESCENDING)
              .publishDate(SortDirection.DESCENDING)
              .title(SortDirection.DESCENDING),
        },
      ).subscribe(
        async (snapshot) => {
          const { isSynced, items } = snapshot;

          // console.log("syncProducts", isSynced, items);
          this.syncedProductArray = items;

          if (
            items?.length > 0 &&
            !this.changingDatastoreConfig &&
            !this.queryingAppsyncProducts
          ) {
            // console.log("queryProductsAndBundles from syncProducts");
            this.queryProductsAndBundles();
          }

          if (isSynced) {
            this.syncedProducts = true;
          } else {
            this.syncedProducts = false;
          }
        },
        // (error) => {
        //   console.log("syncProducts error: ", error);
        // }
      );

      store.commit("addSubscription", {
        model: "Product",
        sub: productSubscription,
      });
    },

    syncProductBundles() {
      // const search = this.productsSearch ? this.productsSearch.split(" ") : [];

      const productBundleSubscription = DataStore.observeQuery(
        ProductBundle,
        Predicates.ALL,
        // (product) =>
        //   product.and((f) => [
        //     this.viewMySubscribedProducts && !this.viewMyBoughtProducts
        //       ? f.id("eq", null)
        //       : true,

        //     f.thumbnails("gt", []),
        //     f.publishDate("lt", this.currentDateTime),
        //     search
        //       .map((str) => str.toLowerCase())
        //       .every((string) => f.searchField("contains", string)),

        //     this.viewMyBoughtProducts
        //       ? this.syncedBoughtProducts?.length > 0
        //         ? f.or((f) =>
        //             this.syncedBoughtProducts.reduce(
        //               (c, pS) => c.id("eq", pS),
        //               f
        //             )
        //           )
        //         : f.id("eq", null)
        //       : true,

        //     this.showFeatured ? f.featured("eq", true) : true,
        //     this.productsSearchTags.some((tag) => f.tags("contains", tag)),
        //     this.routeCategory
        //       ? f.or((f) =>
        //           this.routeCategoryArray.reduce(
        //             (c, id) => c.categoryId("eq", id),
        //             f
        //           )
        //         )
        //       : true,
        //     f.or((f) =>
        //       this.productsSearchCategories.reduce(
        //         (c, id) => c.categoryId("eq", id),
        //         f
        //       )
        //     ),
        //   ]),
        {
          sort: (s) =>
            s
              .featured(SortDirection.DESCENDING)
              .publishDate(SortDirection.DESCENDING)
              .title(SortDirection.DESCENDING),
        },
      ).subscribe(
        async (snapshot) => {
          const { isSynced, items } = snapshot;

          this.syncedProductBundleArray = items;

          if (
            items?.length > 0 &&
            !this.changingDatastoreConfig &&
            !this.queryingAppsyncProducts
          ) {
            // console.log("queryProductsAndBundles from syncProductBundles");
            this.queryProductsAndBundles();
          }

          if (isSynced) {
            this.syncedProductBundles = true;
          } else {
            this.syncedProductBundles = false;
          }
        },
        (error) => {
          console.log(error);
        },
      );

      store.commit("addSubscription", {
        model: "ProductBundle",
        sub: productBundleSubscription,
      });
    },
  },

  beforeDestroy() {
    store.commit("removeSubscriptions", [
      "Product",
      "ProductBundle",
      "ProductTag",
      "ProductCategory",
    ]);

    store.commit("removeDatastorePredicates", [
      "Product",
      "ProductBundle",
      "ProductTag",
      "ProductCategory",
    ]);

    if (this.observeToolbarCart) {
      this.observeToolbarCart.disconnect();
    }
  },
};
</script>
<style lang="scss">
.bundle-chip {
  border: 1px solid #ff0082 !important;
}

.bundle-chip-route {
  border: 1px solid #fae472 !important;
}

.pulsing-star {
  animation: pulse 1.8s infinite ease-in-out;
  height: 20px !important;
  margin-left: -6px !important;
  margin-right: 6px !important;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  70% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

.similar-products-expand-panels i {
  color: white !important;
}

.video-click-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  z-index: 5; /* Ensure it's above the iframe but below any controls if added later */
  cursor: pointer;
}

/* Hiding scrollbar for Chrome, Safari and Opera */
#selectedProductThumbnails::-webkit-scrollbar {
  display: none;
}

/* Hiding scrollbar for IE, Edge and Firefox */
#selectedProductThumbnails {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.productsSearchInputCSS .v-input__slot {
  margin-bottom: 0px !important;
}

.productsSearchInputCSS .v-select__selections {
  min-height: 36px !important;
}

/* Table-specific styling */
.tiptap {
  table {
    border-collapse: collapse;
    table-layout: fixed;
    max-width: 100% !important;
    width: auto !important;
    min-width: 200px !important;
    margin: 0;
    overflow: hidden;

    td,
    th {
      min-width: 1em;
      border: 2px solid #ced4da;
      padding: 3px 5px;
      vertical-align: top;
      box-sizing: border-box;
      position: relative;

      > * {
        margin-bottom: 0;
      }
    }

    th {
      font-weight: bold;
      text-align: left;
      background-color: #f1f3f5;
    }

    .selectedCell:after {
      z-index: 2;
      position: absolute;
      content: "";
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: rgba(200, 200, 255, 0.4);
      pointer-events: none;
    }

    .column-resize-handle {
      position: absolute;
      right: -2px;
      top: 0;
      bottom: -2px;
      width: 4px;
      background-color: #adf;
      pointer-events: none;
    }
  }

  li {
    p {
      margin-bottom: 0;
    }
  }

  ul {
    margin-bottom: 16px;
  }

  ol {
    margin-bottom: 16px;
  }
}

.tableWrapper {
  overflow-x: auto;
}

.v-expansion-panel-content__wrap {
  padding: 0 !important;
}
</style>
